﻿(()=>{
  if(window.__hfdPrintify)return;window.__hfdPrintify=1;
  // Shopify hides line-item properties whose names start with "_". Everything else is
  // printed on the cart and at checkout. Front/Back Design stay visible. "Personalization ID"
  // stays exact: Printify's Shopify importer looks for that name, and renaming it drops the
  // design off the order they import.
  const CUSTOMER_LINE_PROPS=new Set(['Front Design','Back Design','Personalization ID']);
  const INTERNAL_LINE_PROPS=new Set(['Front Cross Section','Front Split Style','Front Line Size','Front Line Color','Back Cross Section','Back Split Style','Back Line Size','Back Line Color','Product','Options','Size','Flag Type','Your design','personalisation_instructions','personalisation_strategy']);
  function customerPropertyName(key){
    const name=String(key||'');
    if(!name||name.charAt(0)==='_'||CUSTOMER_LINE_PROPS.has(name))return name;
    return INTERNAL_LINE_PROPS.has(name)?`_${name}`:name;
  }
  function hideInternalLineProperties(properties){
    const next={};
    Object.entries(properties||{}).forEach(([key,value])=>{
      if(value===undefined||value===null||value==='')return;
      const name=customerPropertyName(key);
      if(next[name]==null||next[name]==='')next[name]=value;
    });
    return next;
  }
  function rewriteCartBody(body){
    if(!body)return body;
    if(typeof FormData!=='undefined'&&body instanceof FormData){
      const next=new FormData();
      [...body.entries()].forEach(([key,value])=>{
        const match=String(key).match(/^properties\[(.*)\]$/);
        if(!match){next.append(key,value);return;}
        const name=customerPropertyName(match[1]);
        if(value==null||value==='')return;
        next.append(`properties[${name}]`,value);
      });
      return next;
    }
    if(typeof body==='string'){
      try{
        const data=JSON.parse(body);
        if(!data||typeof data!=='object')return body;
        if(data.properties)data.properties=hideInternalLineProperties(data.properties);
        if(Array.isArray(data.items))data.items.forEach(item=>{if(item&&item.properties)item.properties=hideInternalLineProperties(item.properties);});
        return JSON.stringify(data);
      }catch(_){return body;}
    }
    return body;
  }
  if(!window.__2in1CartPropertyFetch){
    window.__2in1CartPropertyFetch=1;
    const nativeFetch=window.fetch.bind(window);
    window.fetch=function(input,init){
      try{
        const url=typeof input==='string'?input:input instanceof URL?input.href:(input&&input.url)||'';
        if(/\/cart\/(add|change)\.js(\?|$)/.test(url)&&init&&init.body)init={...init,body:rewriteCartBody(init.body)};
      }catch(_){}
      return nativeFetch(input,init);
    };
  }
  const API='https://us-central1-in1flags-579e0.cloudfunctions.net';
  const SHOP_ID=28834369;
  // Set per export from the ordered flag size. Merch that is not a flag stays 3:2, matching the designer.
  let exportW=5400, exportH=3600;
  const MOCKUP_CONCURRENCY=1;
  let previewChain=Promise.resolve();
  function enqueuePreview(task){
    const run=previewChain.then(()=>task(),()=>task());
    previewChain=run.then(()=>undefined,()=>undefined);
    return run;
  }
  const DEBUG_KEY='2in1flags:debug-mockups';
  function mockupDebugEnabled(){
    try{
      if(new URLSearchParams(location.search).get('debugMockups')==='1')return true;
      if(localStorage.getItem(DEBUG_KEY)==='1')return true;
    }catch(_){}
    return false;
  }
  const mockupLog={
    enabled:mockupDebugEnabled(),
    steps:[],
    lastError:null,
    note(step,detail){
      const entry={t:new Date().toISOString(),step,detail:detail||null};
      this.steps.push(entry);
      if(this.steps.length>80)this.steps.shift();
      if(this.enabled)console.log('[2in1 mockup]',step,detail||'');
    },
    warn(step,detail){
      const entry={t:new Date().toISOString(),step,detail:detail||null,level:'warn'};
      this.steps.push(entry);
      if(this.steps.length>80)this.steps.shift();
      console.warn('[2in1 mockup]',step,detail||'');
    },
    error(step,detail){
      this.lastError={t:new Date().toISOString(),step,detail:detail||null};
      this.steps.push({...this.lastError,level:'error'});
      if(this.steps.length>80)this.steps.shift();
      console.error('[2in1 mockup]',step,detail||'');
    },
    dump(){
      return {
        enabled:this.enabled,
        lastError:this.lastError,
        steps:this.steps.slice(),
        store:window.__2in1Mockups||null,
        key:MOCKUP_KEY,
        tip:'Add ?debugMockups=1 to the URL, or localStorage.setItem("2in1flags:debug-mockups","1") then reload. Inspect window.__2in1MockupDebug.dump()'
      };
    }
  };
  window.__2in1MockupDebug=mockupLog;
  if(mockupLog.enabled)console.info('[2in1 mockup] debug ON — watch console, or run __2in1MockupDebug.dump()');
  const catalogApi=()=>window.__2in1PrintifyCatalog||{};
  const CATALOG=new Proxy({},{get(_,key){return (catalogApi().byKey||{})[key]||{handle:''};}});
  const PRINTIFY_IDS=new Proxy({},{get(_,key){return (catalogApi().ids||{})[key]||'';}});
  const FRONT_LAYER='Front Design';
  const BACK_LAYER='Back Design';
  const MOCKUP_KEY='2in1flags:printify-mockups:v10';
  const sleep=ms=>new Promise(r=>setTimeout(r,ms));
  function abortAfter(ms){
    if(typeof AbortSignal!=='undefined'&&typeof AbortSignal.timeout==='function')return AbortSignal.timeout(ms);
    const controller=new AbortController();
    setTimeout(()=>controller.abort(),ms);
    return controller.signal;
  }
  const norm=value=>String(value||'').toLowerCase();
  const layerKey=value=>String(value||'').toLowerCase().replace(/[_-]+/g,' ').trim();
  function findLayer(options,name){
    const want=layerKey(name);
    return (options||[]).find(field=>layerKey(field.label)===want||layerKey(field.name)===want||layerKey(field.field_id)===want)||null;
  }

  const geo=()=>window.__2in1FlagGeometry;
  const regionPolys=d=>geo().regionPolys(d);
  const paths=d=>geo().lineSegments(d);
  function pathPoly(ctx,poly,w,h){ctx.beginPath();poly.forEach((p,i)=>(i?ctx.lineTo:ctx.moveTo).call(ctx,p[0]/100*w,p[1]/100*h));ctx.closePath()}
  const FLAG_FILES='https://cdn.shopify.com/s/files/1/1060/5084/7062/files/';
  const EDGE_OVERSCAN=1.015;
  async function bitmap(url,fallbacks=[]){
    const primary=String(url||'');
    if(!primary)throw new Error('Could not load design image');
    const seen=new Set();
    const queue=[];
    const enqueue=src=>{
      const value=String(src||'').trim();
      if(!value||seen.has(value))return;
      seen.add(value);
      queue.push(value);
      if(/^https?:\/\//i.test(value)){
        const proxied=`${API}/proxyImage?url=${encodeURIComponent(value)}`;
        if(!seen.has(proxied)){seen.add(proxied);queue.push(proxied);}
      }
    };
    enqueue(primary);
    (fallbacks||[]).forEach(enqueue);
    let lastErr=null;
    for(const candidate of queue){
      try{
        const r=await fetch(candidate,{mode:'cors',credentials:'omit',signal:abortAfter(20000)});
        if(!r.ok){lastErr=new Error(`Could not load design image (${r.status})`);continue;}
        return createImageBitmap(await r.blob());
      }catch(err){
        lastErr=err;
      }
    }
    throw lastErr||new Error('Could not load design image');
  }
  function isUploadItem(item){
    return item?.type==='upload'||item?.type==='my-uploads'||!!item?.uploadId;
  }
  function uploadIdOf(item){
    const id=String(item?.uploadId||'').trim();
    if(id&&id!=='upload')return id;
    const value=String(item?.value||'').trim();
    if(/^up_/i.test(value))return value;
    return '';
  }
  async function readStoredUpload(id){
    if(!id)return '';
    try{
      const fromStore=await window.__hfdUploadStore?.getImage?.(id);
      if(fromStore?.dataUrl)return fromStore.dataUrl;
    }catch(_){}
    try{
      const db=await new Promise((resolve,reject)=>{
        const req=indexedDB.open('2in1flags-uploads',2);
        req.onupgradeneeded=()=>{if(!req.result.objectStoreNames.contains('images'))req.result.createObjectStore('images');};
        req.onsuccess=()=>resolve(req.result);
        req.onerror=()=>reject(req.error);
      });
      const rec=await new Promise((resolve,reject)=>{
        const req=db.transaction('images','readonly').objectStore('images').get(id);
        req.onsuccess=()=>resolve(req.result||null);
        req.onerror=()=>reject(req.error);
      });
      return rec?.dataUrl||'';
    }catch(_){
      return '';
    }
  }
  function readUploadMeta(){
    try{return JSON.parse(localStorage.getItem('2in1flags:design:upload-meta:v1')||'null');}catch(_){return null;}
  }
  function metaUploadId(side,index){
    const id=String(readUploadMeta()?.[side]?.[index]?.id||'').trim();
    return id&&id!=='upload'?id:'';
  }
  function keepUploadIds(design,existing){
    if(!design)return design;
    const meta=readUploadMeta();
    ['front','back'].forEach(side=>{
      (design[side]?.items||[]).forEach((item,index)=>{
        if(!isUploadItem(item)||uploadIdOf(item))return;
        const prev=existing?.[side]?.items?.[index];
        const id=uploadIdOf(prev)||String(meta?.[side]?.[index]?.id||'').trim();
        if(!id||id==='upload')return;
        item.uploadId=id;
        if(!item.value||item.value==='upload')item.value=id;
      });
    });
    return design;
  }
  function itemUrl(item){
    if(item?.type==='text')return '';
    if(isUploadItem(item)){
      if(item.imageUrl)return item.imageUrl;
      if(String(item.value||'').startsWith('data:'))return item.value;
      return '';
    }
    const value=String(item?.value||'').trim();
    const isCountry=item?.type==='country'||(!item?.type&&/^[a-z]{2}$/i.test(value));
    // Country/sports must follow the design value — never a stale layer <img> (hidden Back often still shows visitor/Haiti).
    if(isCountry&&/^[a-z]{2}$/i.test(value)){
      return window.__2in1FlagLibrary?.countryArtworkUrl?.(value)||`https://flagcdn.com/w2560/${value.toLowerCase()}.png`;
    }
    if(value&&!value.startsWith('data:')&&!/^[a-z]{2}$/i.test(value)){
      const remote=String(item?.imageUrl||item?.previewUrl||'').trim();
      if(remote.startsWith('data:image/')||remote.startsWith('blob:'))return remote;
      if(/^https?:\/\//i.test(remote)&&!/flagcdn\.com\/(?:w\d+\/)?[a-z]{2}(?:\.png)?/i.test(remote))return remote;
      return `${FLAG_FILES}${value.replace(/\.png$/i,'')}.png`;
    }
    const remote=String(item?.imageUrl||item?.previewUrl||'').trim();
    if(/^https?:\/\//i.test(remote)||remote.startsWith('data:image/')||remote.startsWith('blob:'))return remote;
    return '';
  }
  function polyBox(poly,w,h){
    const xs=poly.map(p=>p[0]/100*w),ys=poly.map(p=>p[1]/100*h);
    const x=Math.max(0,Math.min(...xs)),y=Math.max(0,Math.min(...ys));
    return {x,y,w:Math.max(1,Math.min(w,Math.max(...xs))-x),h:Math.max(1,Math.min(h,Math.max(...ys))-y)};
  }
  function panVector(cross,value){
    const n=Number(value);const v=Number.isFinite(n)?n:1;
    if(cross==='diag-left'||cross==='diag-right'){
      const col=v%3,row=Math.floor(v/3);
      return {x:col===0?1:col===2?-1:0,y:row===0?1:row===2?-1:0};
    }
    if(v===1)return {x:0,y:0};
    const d=v===0?1:-1;
    if(['vertical','t-left','t-right'].includes(cross))return {x:d,y:0};
    if(['horizontal','t-top','t-bottom','single'].includes(cross))return {x:0,y:d};
    return {x:d,y:d};
  }
  function visibleBounds(img){
    const nw=img.width||1,nh=img.height||1;
    try{
      const max=320,ratio=Math.min(1,max/Math.max(nw,nh));
      const w=Math.max(1,Math.round(nw*ratio)),h=Math.max(1,Math.round(nh*ratio));
      const c=document.createElement('canvas');c.width=w;c.height=h;
      const cctx=c.getContext('2d',{willReadFrequently:true});
      cctx.drawImage(img,0,0,w,h);
      const data=cctx.getImageData(0,0,w,h).data;
      let minX=w,minY=h,maxX=-1,maxY=-1;
      for(let y=0;y<h;y++)for(let x=0;x<w;x++)if(data[(y*w+x)*4+3]>12){if(x<minX)minX=x;if(x>maxX)maxX=x;if(y<minY)minY=y;if(y>maxY)maxY=y;}
      if(maxX<minX||maxY<minY)return {x:0,y:0,w:1,h:1};
      const pad=1;
      minX=Math.max(0,minX-pad);minY=Math.max(0,minY-pad);
      maxX=Math.min(w-1,maxX+pad);maxY=Math.min(h-1,maxY+pad);
      return {x:minX/w,y:minY/h,w:(maxX-minX+1)/w,h:(maxY-minY+1)/h};
    }catch(_){return {x:0,y:0,w:1,h:1};}
  }
  function sourceBounds(img,item){
    const stored=item?.visibleBounds;
    if(stored&&Number(stored.w)>0&&Number(stored.h)>0){
      if(stored.w<=1&&stored.h<=1)return {x:Number(stored.x)||0,y:Number(stored.y)||0,w:Number(stored.w),h:Number(stored.h)};
      const nw=img.width||1,nh=img.height||1;
      return {x:stored.x/nw,y:stored.y/nh,w:stored.w/nw,h:stored.h/nh};
    }
    return visibleBounds(img);
  }
  function fillsWholeFlag(p){
    const x=Number(p?.x)||0,y=Number(p?.y)||0,w=Number(p?.w),h=Number(p?.h);
    return Math.abs(x)<0.02&&Math.abs(y)<0.02&&Math.abs(w-1)<0.02&&Math.abs(h-1)<0.02;
  }
  function regionIsPartial(poly,section){
    if(section.w<exportW-1||section.h<exportH-1)return true;
    if(!poly||poly.length!==4)return true;
    const corners=[[0,0],[100,0],[100,100],[0,100]];
    return !corners.every(c=>poly.some(p=>Math.abs(p[0]-c[0])<0.51&&Math.abs(p[1]-c[1])<0.51));
  }
  function drawSectionFit(ctx,img,item,poly,d){
    const section=polyBox(poly,exportW,exportH);
    const p=item?.presentation;
    const partial=regionIsPartial(poly,section);
    // Presentation is captured against the full designer layer. Use it when it
    // encodes pan/zoom. If it still says "fill the whole flag" while this item
    // only occupies a clipped region, fit into that region like the on-screen layout.
    if(p&&Number(p.w)>0&&Number(p.h)>0&&!(partial&&fillsWholeFlag(p))){
      ctx.drawImage(img,Number(p.x)*exportW,Number(p.y)*exportH,Number(p.w)*exportW,Number(p.h)*exportH);
      return;
    }
    const nw=img.width||1,nh=img.height||1;
    const bounds=sourceBounds(img,item);
    const bx=bounds.x*nw,by=bounds.y*nh;
    const bw=Math.max(1,bounds.w*nw),bh=Math.max(1,bounds.h*nh);
    const fitEntire=!!item.fitEntire;
    const userScale=Math.max(50,Math.min(200,Number(item.scale)||100))/100;
    const baseScale=fitEntire?Math.min(section.w/bw,section.h/bh):Math.max(section.w/bw,section.h/bh)*EDGE_OVERSCAN;
    const scale=baseScale*userScale;
    const iw=nw*scale,ih=nh*scale;
    let left=section.x+section.w/2-(bx+bw/2)*scale;
    let top=section.y+section.h/2-(by+bh/2)*scale;
    const visibleLeft=left+bx*scale,visibleTop=top+by*scale;
    const visibleRight=visibleLeft+bw*scale,visibleBottom=visibleTop+bh*scale;
    const v=panVector(d.cross,item.focus??1);
    if(v.x>0)left+=section.x-visibleLeft;
    else if(v.x<0)left+=section.x+section.w-visibleRight;
    if(v.y>0)top+=section.y-visibleTop;
    else if(v.y<0)top+=section.y+section.h-visibleBottom;
    ctx.drawImage(img,left,top,iw,ih);
  }
  function hasSides(d){return !!(d?.front?.items&&d?.back?.items);}
  function hasSideContent(side){
    return !!(side&&Array.isArray(side.items)&&side.items.length&&Number(side.count||side.items.length)>0);
  }
  function mergeSidePresentation(base,extra){
    if(!base)return extra||null;
    if(!extra)return base;
    const copy=JSON.parse(JSON.stringify(base));
    if(extra.count!=null)copy.count=extra.count;
    if(extra.cross)copy.cross=extra.cross;
    if(extra.lineSize!=null)copy.lineSize=extra.lineSize;
    if(extra.lineColor)copy.lineColor=extra.lineColor;
    const items=copy.items||[];
    (extra.items||[]).forEach((from,index)=>{
      if(!items[index]||!from)return;
      if(from.presentation)items[index].presentation=from.presentation;
      if(from.visibleBounds)items[index].visibleBounds=from.visibleBounds;
      // Only keep upload/data image URLs — never stamp a stale flagcdn layer onto country/sports values.
      if(from.imageUrl&&(isUploadItem(from)||String(from.imageUrl).startsWith('data:')||String(from.imageUrl).startsWith('blob:'))){
        items[index].imageUrl=from.imageUrl;
      }
      if(from.scale!=null)items[index].scale=from.scale;
      if(from.fitEntire!=null)items[index].fitEntire=from.fitEntire;
      if(from.focus!=null)items[index].focus=from.focus;
      if(from.uploadId)items[index].uploadId=from.uploadId;
    });
    return copy;
  }
  function visitorCountryCode(){
    const root=document.querySelector('[data-hfd]');
    return String(root?.dataset?.visitorCountry||'us').toLowerCase();
  }
  /** Authoritative design for Apply/ATC: live designer emit first, then DOM snapshot, then draft. */
  function liveDesignBundle(){
    const emitted=window.__twoInOneFlagDesignState;
    if(hasSides(emitted)){
      return {
        front:emitted.front,
        back:emitted.back,
        side:emitted.side||'front',
        source:'emit'
      };
    }
    const snap=typeof window.twoInOneSavedDesignState==='function'?window.twoInOneSavedDesignState():null;
    if(hasSides(snap)){
      return {front:snap.front,back:snap.back,side:snap.side||'front',source:'snap'};
    }
    const stored=readDraft();
    if(hasSides(stored)){
      return {front:stored.front,back:stored.back,side:stored.side||'front',source:'draft'};
    }
    return null;
  }
  function liveLayout(side){
    const bundle=liveDesignBundle();
    if(hasSideContent(bundle?.[side]))return bundle[side];
    const liquid=window.__twoInOneFlagDesignState;
    if(hasSideContent(liquid?.[side]))return liquid[side];
    return null;
  }
  function designerDraft(stored){
    const bundle=liveDesignBundle();
    if(bundle){
      return {
        ...(stored||{}),
        front:bundle.front,
        back:bundle.back,
        side:bundle.side||stored?.side||'front',
        _designSource:bundle.source
      };
    }
    if(hasSides(stored))return stored;
    return stored;
  }
  function sideNodes(root,side,selector){
    const pane=window.hfdUi?.pane?.(root,side);
    const fromPane=selector==='[data-layer]'?pane?.layers:selector==='[data-select-row]'?pane?.rows:null;
    if(fromPane?.length)return fromPane;
    return [...(root||document).querySelectorAll(`[data-hfd-side="${side}"] ${selector}`)];
  }
  function captureDomLayout(side,copy){
    const root=document.querySelector('[data-hfd]');
    if(!root||!copy)return copy;
    // Presentation only — never overwrite designer type/value/count or stamp stale layer imgs as imageUrl.
    const layers=sideNodes(root,side,'[data-layer]');
    const rows=sideNodes(root,side,'[data-select-row]');
    if(!layers.length&&!rows.length)return copy;
    (copy.items||[]).forEach((item,index)=>{
      if(item?.type==='text')return;
      const row=rows[index];
      const layer=layers[index];
      const img=layer?.querySelector('img');
      const fit=row?.querySelector('[data-fit-entire]');
      const scale=row?.querySelector('[data-image-scale]');
      if(fit)item.fitEntire=!!fit.checked;
      if(scale)item.scale=Number(scale.value)||item.scale||100;
      if(!img)return;
      const src=img.currentSrc||img.src||'';
      // Uploads only: country/sports resolve from value in itemUrl (hidden Back layers often still show Haiti/visitor).
      if(isUploadItem(item)||src.startsWith('data:')||src.startsWith('blob:')){
        if(src)item.imageUrl=src;
        else if(row?.dataset?.libraryImage)item.imageUrl=row.dataset.libraryImage;
      }else if(item.imageUrl&&/^https?:\/\//i.test(String(item.imageUrl))){
        delete item.imageUrl;
      }
      const lr=layer.getBoundingClientRect(),ir=img.getBoundingClientRect();
      if(lr.width&&lr.height&&ir.width&&ir.height){
        item.presentation={x:(ir.left-lr.left)/lr.width,y:(ir.top-lr.top)/lr.height,w:ir.width/lr.width,h:ir.height/lr.height};
      }
      try{if(img.dataset.visibleBounds)item.visibleBounds=JSON.parse(img.dataset.visibleBounds);}catch(_){}
    });
    return copy;
  }
  async function hydrateUploads(side,state,opts){
    const copy=JSON.parse(JSON.stringify(state||{}));
    const layoutSide=opts?.layoutSide||side;
    const live=window.__hfdUploadState?.[layoutSide]||[];
    const saved=opts?.skipLiveLayout?null:liveLayout(layoutSide);
    const items=copy.items||[];
    // `state` from ensureUploads is authoritative for type/value/count/cross.
    // liveLayout may still be visitor/Haiti on Back — only borrow presentation/upload bytes.
    if(hasSideContent(saved)){
      if(copy.lineSize==null&&saved.lineSize!=null)copy.lineSize=saved.lineSize;
      if(!copy.lineColor&&saved.lineColor)copy.lineColor=saved.lineColor;
      (saved.items||[]).forEach((fromSaved,i)=>{
        if(!items[i]||!fromSaved)return;
        if(!items[i].presentation&&fromSaved.presentation)items[i].presentation=fromSaved.presentation;
        if(!items[i].visibleBounds&&fromSaved.visibleBounds)items[i].visibleBounds=fromSaved.visibleBounds;
        if(items[i].scale==null&&fromSaved.scale!=null)items[i].scale=fromSaved.scale;
        if(items[i].fitEntire==null&&fromSaved.fitEntire!=null)items[i].fitEntire=fromSaved.fitEntire;
        if(items[i].focus==null&&fromSaved.focus!=null)items[i].focus=fromSaved.focus;
        if(isUploadItem(items[i])){
          if(fromSaved.uploadId)items[i].uploadId=fromSaved.uploadId;
          if(fromSaved.imageUrl&&(String(fromSaved.imageUrl).startsWith('data:')||String(fromSaved.imageUrl).startsWith('blob:'))){
            items[i].imageUrl=fromSaved.imageUrl;
          }
        }
      });
    }
    for(let i=0;i<items.length;i++){
      const item=items[i];
      if(item?.type==='text')continue;
      const u=live[i];
      if(u?.enabled&&u.dataUrl){
        item.type='upload';
        item.imageUrl=u.dataUrl;
        item.scale=u.scale||item.scale||100;
        item.fitEntire=u.fitEntire??item.fitEntire;
        continue;
      }
      if(isUploadItem(item)&&!String(item.imageUrl||'').startsWith('data:')&&!/^https?:\/\//i.test(item.imageUrl||'')){
        const id=uploadIdOf(item)||u?.id||metaUploadId(layoutSide,i);
        if(id)item.uploadId=id;
        const dataUrl=await readStoredUpload(id);
        if(dataUrl){
          item.type='upload';
          item.imageUrl=dataUrl;
        }
      }
    }
    return captureDomLayout(layoutSide,copy);
  }
  function textLayoutApi(){return window.__2in1FlagTextLayout||null;}
  function assertPrintableText(spec,where){
    const api=textLayoutApi();
    if(!api?.draw)throw new Error('Text tool is still loading. Reload the page, then Apply again.');
    const blocked=api.blockedReason?.(spec?.text)||'';
    if(blocked)throw new Error(blocked);
    if(!String(spec?.text||'').trim())throw new Error(`Add text to ${where}`);
  }
  function printPixels(sizeLabel){
    const api=window.__2in1FlagPrint;
    if(api?.pixelsFor)return api.pixelsFor(sizeLabel||api.currentLabel?.()||'');
    return {key:'3x2',width:5400,height:3600,dpi:150};
  }
  function openPrintCanvas(width,height){
    const canvas=document.createElement('canvas');
    const fit=(w,h)=>{
      try{
        canvas.width=w;canvas.height=h;
        const ctx=canvas.getContext('2d');
        if(!ctx||canvas.width!==w||canvas.height!==h)return null;
        return ctx;
      }catch(_){return null;}
    };
    let ctx=fit(width,height);
    let scale=Math.min(1,8192/Math.max(width,height));
    while(!ctx&&scale>=0.25){
      ctx=fit(Math.max(2,Math.round(width*scale)),Math.max(2,Math.round(height*scale)));
      scale*=0.8;
    }
    if(!ctx)throw new Error('This browser could not create the print file');
    if(canvas.width!==width||canvas.height!==height){
      mockupLog.warn('export:canvas-clamped',{asked:[width,height],got:[canvas.width,canvas.height]});
    }
    return {canvas,ctx};
  }
  function canvasJpegBase64(canvas){
    const quality=0.92;
    return new Promise((resolve,reject)=>{
      const finish=dataUrl=>{
        const comma=String(dataUrl||'').indexOf(',');
        if(comma<0){reject(new Error('Could not encode print file'));return;}
        resolve(dataUrl.slice(comma+1));
      };
      if(typeof canvas.toBlob==='function'){
        canvas.toBlob(blob=>{
          if(!blob){reject(new Error('Could not encode print file'));return;}
          const reader=new FileReader();
          reader.onload=()=>finish(reader.result);
          reader.onerror=()=>reject(reader.error||new Error('Could not encode print file'));
          reader.readAsDataURL(blob);
        },'image/jpeg',quality);
        return;
      }
      finish(canvas.toDataURL('image/jpeg',quality));
    });
  }
  async function exportDesign(d,sideName,sizeLabel){
    const api=textLayoutApi();
    if(api?.ready)await api.ready();
    const px=printPixels(sizeLabel);
    const opened=openPrintCanvas(px.width,px.height);
    const canvas=opened.canvas;
    exportW=canvas.width;exportH=canvas.height;
    const ctx=opened.ctx;ctx.fillStyle='#fff';ctx.fillRect(0,0,exportW,exportH);
    mockupLog.note('export:size',{side:sideName,label:sizeLabel||'',key:px.key,width:exportW,height:exportH});
    const polys=regionPolys(d),items=d.items||[];
    const side=sideName==='back'?'back':'front';
    for(let i=0;i<d.count;i++){
      const item=items[i]||{};
      const poly=polys[i];
      ctx.save();
      try{
        pathPoly(ctx,poly,exportW,exportH);ctx.clip();
        if(item.type==='text'){
          // Glyphs are filled at this side's print size. The on-screen preview is a separate draw.
          assertPrintableText(item,`${side} section ${i+1}`);
          api.draw(ctx,item,poly,d.count,exportW,exportH,{background:true});
        }else{
          const url=itemUrl(item);
          if(!url){
            // Never print a blank region: an upload whose bytes are not available on this page (e.g. a saved
            // design whose image is missing from this browser) must fail Apply instead of shipping white.
            mockupLog.error('export:missing-item',{index:i,type:item?.type,value:String(item?.value||'').slice(0,40),uploadId:item?.uploadId||'',hasImageUrl:!!item?.imageUrl});
            throw new Error(`Could not load design image (missing upload in slot ${i+1})`);
          }
          const value=String(item?.value||'').trim().toLowerCase();
          const fallbacks=[];
          if(/^[a-z]{2}$/.test(value)){
            const flagcdn=`https://flagcdn.com/w2560/${value}.png`;
            if(flagcdn!==url)fallbacks.push(flagcdn);
          }
          const img=await bitmap(url,fallbacks);
          drawSectionFit(ctx,img,item,poly,d);
          img.close?.();
          if(String(item.overlay?.text||'').trim()){
            assertPrintableText(item.overlay,`${side} section ${i+1}`);
            api.draw(ctx,item.overlay,poly,d.count,exportW,exportH,{background:false});
          }
        }
      }finally{
        ctx.restore();
      }
    }
    ctx.strokeStyle=d.lineColor||'#087df5';ctx.lineWidth=Math.max(2,(d.lineSize||16)*exportW/760/2);ctx.lineCap='round';ctx.lineJoin='round';
    for(const seg of paths(d)){
      ctx.beginPath();seg.forEach((p,i)=>(i?ctx.lineTo:ctx.moveTo).call(ctx,p[0]/100*exportW,p[1]/100*exportH));ctx.stroke();
    }
    // JPEG at 0.92 keeps a full-size flag under a few megabytes. The canvas is already on white.
    return canvasJpegBase64(canvas);
  }
  const UPLOAD_RETRY_DELAYS=[2000,5000];
  async function upload(contents,name){
    const body=JSON.stringify({file_name:name,contents});
    let lastError=null;
    for(let attempt=0;attempt<=UPLOAD_RETRY_DELAYS.length;attempt++){
      mockupLog.note('upload:start',{name,bytes:contents?.length||0,attempt});
      try{
        const r=await fetch(`${API}/printifyUpload`,{method:'POST',headers:{'Content-Type':'application/json'},body,signal:abortAfter(170000)});
        const data=await r.json().catch(()=>({}));
        if(r.ok){
          mockupLog.note('upload:ok',{name,preview_url:data.preview_url||data.id||null,width:data.width||null,height:data.height||null});
          return data;
        }
        const transient=[429,502,503,504].includes(r.status);
        lastError=new Error(data.details?.errors?.reason||data.details?.message||data.error||'Printify upload failed');
        if(transient&&attempt<UPLOAD_RETRY_DELAYS.length){
          mockupLog.warn('upload:retry',{name,status:r.status,attempt});
          await sleep(UPLOAD_RETRY_DELAYS[attempt]);
          continue;
        }
        mockupLog.error('upload:fail',{name,status:r.status,data});
        throw lastError;
      }catch(err){
        if(err===lastError)throw err;
        const aborted=err?.name==='AbortError'||err?.name==='TimeoutError'||/aborted|timeout/i.test(String(err?.message||err));
        const network=err instanceof TypeError;
        lastError=aborted?new Error('Printify upload timed out'):err;
        if((aborted||network)&&attempt<UPLOAD_RETRY_DELAYS.length){
          mockupLog.warn('upload:retry',{name,attempt,message:String(err?.message||err)});
          await sleep(UPLOAD_RETRY_DELAYS[attempt]);
          continue;
        }
        mockupLog.error('upload:fail',{name,message:String(lastError?.message||lastError)});
        throw lastError;
      }
    }
    throw lastError||new Error('Printify upload failed');
  }
  async function createPreview(productId,variantId,frontUrl,backUrl,fields,options){
    if(options?.background){
      // Do not hold the foreground chain for a long background poll: wait for the queue to drain, then run alongside.
      await previewChain.catch(()=>undefined);
      return createPreviewJob(productId,variantId,frontUrl,backUrl,fields,options);
    }
    return enqueuePreview(()=>createPreviewJob(productId,variantId,frontUrl,backUrl,fields,options));
  }
  // Printify's personalization queue can leave a task pending for many minutes. Remember the task per
  // product/variant/design so "try again" or a refresh resumes it instead of queuing yet another render.
  const PENDING_TASK_KEY='2in1flags:printify-pending-tasks';
  const PENDING_TASK_TTL=60*60*1000;
  const PREVIEW_POLL_MS=150000;
  // Background renders (other flag sizes) are invisible to the shopper, so they may wait out a slow queue.
  const BACKGROUND_POLL_MS=10*60*1000;
  function readPendingTasks(){try{return JSON.parse(sessionStorage.getItem(PENDING_TASK_KEY)||'{}')||{};}catch(_){return {};}}
  function writePendingTasks(map){try{sessionStorage.setItem(PENDING_TASK_KEY,JSON.stringify(map));}catch(_){ }}
  function pendingTaskKey(productId,variantId,frontUrl,backUrl){return [productId,[].concat(variantId).join(','),frontUrl||'',backUrl||''].join('|');}
  function rememberPendingTask(key,taskId){
    const map=readPendingTasks();
    const now=Date.now();
    Object.keys(map).forEach(k=>{if(!map[k]?.task_id||now-(map[k].at||0)>PENDING_TASK_TTL)delete map[k];});
    map[key]={task_id:taskId,at:now};
    writePendingTasks(map);
  }
  function forgetPendingTask(key){
    const map=readPendingTasks();
    if(!(key in map))return;
    delete map[key];
    writePendingTasks(map);
  }
  function resumablePendingTask(key){
    const entry=readPendingTasks()[key];
    if(!entry?.task_id)return '';
    if(Date.now()-(entry.at||0)>PENDING_TASK_TTL){forgetPendingTask(key);return '';}
    return entry.task_id;
  }
  /** `variantId` may be a single Printify variant id or an array — one task renders every listed variant. */
  async function createPreviewJob(productId,variantId,frontUrl,backUrl,fields,options={}){
    const variantIds=[].concat(variantId).map(Number).filter(Boolean);
    const pollMs=options.pollMs||PREVIEW_POLL_MS;
    const background=!!options.background;
    const personalization=[];
    const frontField=findLayer(fields,FRONT_LAYER);
    const backField=findLayer(fields,BACK_LAYER);
    if(frontUrl&&frontField)personalization.push({field_id:frontField.field_id,type:'image',input:{image_url:frontUrl}});
    if(backUrl&&backField)personalization.push({field_id:backField.field_id,type:'image',input:{image_url:backUrl}});
    mockupLog.note('preview:prepare',{
      productId,
      variantId,
      layers:(fields||[]).map(f=>f.label||f.field_id),
      hasFrontLayer:!!frontField,
      hasBackLayer:!!backField,
      personalizationCount:personalization.length,
      frontUrl:!!frontUrl,
      backUrl:!!backUrl
    });
    if(!personalization.length){
      mockupLog.error('preview:no-layers',{productId,layers:(fields||[]).map(f=>f.label||f.field_id)});
      return null;
    }
    const body={shop_id:SHOP_ID,product_id:productId,external_id:`2in1flags-${Date.now()}`,variant_ids:variantIds,personalization};
    const started=Date.now();
    const taskKey=pendingTaskKey(productId,variantId,frontUrl,backUrl);
    let taskId=resumablePendingTask(taskKey);
    let resumed=!!taskId;
    async function startTask(){
      mockupLog.note('preview:queue-run',{productId,variantId});
      const r=await fetch(`${API}/printifyPreview`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:abortAfter(20000)});
      const first=await r.json().catch(()=>({}));
      if(!r.ok){
        mockupLog.error('preview:create-fail',{status:r.status,first,ms:Date.now()-started});
        throw new Error(first.details?.errors?.reason||first.details?.message||first.error||'Preview request failed');
      }
      if(!first.task_id)throw new Error('Preview request returned no task');
      rememberPendingTask(taskKey,first.task_id);
      mockupLog.note('preview:job',{task_id:first.task_id,productId,variantId});
      return first.task_id;
    }
    if(resumed)mockupLog.note('preview:resume',{task_id:taskId,productId,variantId});
    else taskId=await startTask();
    // Printify renders usually land in 45–90s but the queue can stall for many minutes; on timeout we keep
    // the task_id so the next Apply (or a refresh) continues polling instead of adding another render.
    for(let i=0;Date.now()-started<pollMs;i++){
      if(options.shouldAbort?.()){
        // Design changed under a background render — keep the task_id but stop polling for it.
        mockupLog.note('preview:abandoned',{task_id:taskId,variantId,ms:Date.now()-started});
        return null;
      }
      const s=await fetch(`${API}/printifyPreviewStatus?shop_id=${SHOP_ID}&product_id=${productId}&task_id=${encodeURIComponent(taskId)}`,{signal:abortAfter(12000)});
      const data=await s.json().catch(()=>({}));
      if(!s.ok){
        // A resumed task Printify no longer knows about — start fresh once.
        if(resumed&&(s.status===404||s.status===400)){
          mockupLog.warn('preview:resume-expired',{task_id:taskId,status:s.status});
          forgetPendingTask(taskKey);
          resumed=false;
          taskId=await startTask();
          continue;
        }
        mockupLog.warn('preview:poll-http',{status:s.status,task_id:taskId});
        await sleep(1500);
        continue;
      }
      if(i===0||i%15===0||data.status!=='pending'){
        mockupLog.note('preview:poll',{i,status:data.status,task_id:taskId,resumed,ms:Date.now()-started});
      }
      if(data.status==='completed'){
        forgetPendingTask(taskKey);
        const count=(data.mockups||data.data?.mockups||[]).length;
        mockupLog.note('preview:completed',{task_id:taskId,mockupCount:count,resumed,ms:Date.now()-started});
        return data;
      }
      if(data.status==='failed'||data.status==='corrupt'){
        forgetPendingTask(taskKey);
        mockupLog.error('preview:failed',{status:data.status,error:data.error,task_id:taskId,ms:Date.now()-started});
        throw new Error(data.error?.message||'Printify preview failed');
      }
      await sleep(background&&i>=30?3000:i<10?500:1000);
    }
    mockupLog.error('preview:timeout',{task_id:taskId,productId,variantId,resumed,background,ms:Date.now()-started,hint:'Printify left the job pending; task_id kept so the next Apply resumes it.'});
    throw new Error('Printify preview timed out');
  }
  function catalogKeyFromHandle(handle){return catalogApi().catalogKeyFromHandle?catalogApi().catalogKeyFromHandle(handle):'merch';}
  function primaryHandle(handle){return catalogApi().primaryHandle?catalogApi().primaryHandle(handle):handle;}
  function handlesFor(item){return catalogApi().handlesFor?catalogApi().handlesFor(item):[item?.handle].filter(Boolean);}
  function knownByHandle(handle){return catalogApi().knownByHandle?catalogApi().knownByHandle(handle):null;}
  function seedCatalogItems(){return catalogApi().seedItems?catalogApi().seedItems():[];}
  function shopifyHandleFromPrintify(product){
    const ext=String(product?.external?.handle||'');
    const match=ext.match(/\/products\/([^/?#]+)/i);
    return match?decodeURIComponent(match[1]):'';
  }
  function matchesPrintifyHandle(product,handle){
    const want=norm(handle);
    if(!want)return false;
    const extHandle=norm(shopifyHandleFromPrintify(product));
    if(extHandle&&extHandle===want)return true;
    return norm(product?.title).replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'')===want;
  }
  function catalogFromPrintify(product){
    const handle=shopifyHandleFromPrintify(product);
    const known=knownByHandle(handle);
    const fuzzy=handle?CATALOG[catalogKeyFromHandle(handle)]:null;
    return {
      ...(known||fuzzy||CATALOG.merch),
      handle,
      printifyId:product.id,
      blueprintId:product.blueprint_id,
      printProviderId:product.print_provider_id
    };
  }
  function sameProductHandle(a,b){
    const left=primaryHandle(a),right=primaryHandle(b);
    return !!left&&!!right&&left===right;
  }
  function catalogFor(page){
    const handle=page?.dataset.productHandle||'';
    const exact=handle?knownByHandle(handle):null;
    if(exact)return {...exact,handle};
    const key=page?.dataset.catalog||page?.dataset.mockup||catalogKeyFromHandle(handle)||'merch';
    const base=CATALOG[key]||CATALOG.merch;
    if(handle&&base.handle&&!sameProductHandle(base.handle,handle))return {handle,catalog:key};
    return {...base,handle:handle||base.handle};
  }
  let printifyListPromise=null;
  async function printifyProducts(){
    if(printifyListPromise)return printifyListPromise;
    printifyListPromise=(async()=>{
      const all=[];
      const seen=new Set();
      for(let page=1;page<=10;page++){
        const r=await fetch(`${API}/printifyProducts?shop_id=${SHOP_ID}&limit=50&page=${page}`,{signal:abortAfter(20000)});
        if(!r.ok)break;
        const data=await r.json().catch(()=>({}));
        const list=Array.isArray(data.data)?data.data:(Array.isArray(data)?data:[]);
        if(!list.length)break;
        const fresh=list.filter(product=>product?.id&&!seen.has(product.id));
        if(page>1&&!fresh.length)break;
        fresh.forEach(product=>{seen.add(product.id);all.push(product)});
        if(Number(data.last_page||0)&&page>=Number(data.last_page))break;
        if(!data.last_page&&list.length<10)break;
      }
      window.__2in1PrintifyList=all;
      return all;
    })();
    printifyListPromise.catch(()=>{if(printifyListPromise)printifyListPromise=null;});
    return printifyListPromise;
  }
  // Memoised lookups remember their settled value so the add-to-cart click can read them synchronously.
  const settledValues=new WeakMap();
  function track(promise){
    promise.then(value=>settledValues.set(promise,{value}),()=>settledValues.set(promise,{value:null}));
    return promise;
  }
  function peek(promise){return promise?settledValues.get(promise)?.value??null:null;}
  const fieldsCache=new Map();
  async function personalizationFields(productId){
    if(!productId)return [];
    if(fieldsCache.has(productId))return fieldsCache.get(productId);
    const job=track((async()=>{
      const r=await fetch(`${API}/printifyPersonalizationOptions?shop_id=${SHOP_ID}&product_id=${encodeURIComponent(productId)}`,{signal:abortAfter(20000)});
      if(!r.ok)return [];
      const data=await r.json().catch(()=>([]));
      return Array.isArray(data)?data:(data.options||data.fields||[]);
    })());
    job.catch(()=>{if(fieldsCache.get(productId)===job)fieldsCache.delete(productId);});
    fieldsCache.set(productId,job);
    return job;
  }
  /** Ask Printify for the buyer personalization code. Reuses the print-file URLs already uploaded. */
  async function personalizationCode(productId,variantId,frontUrl,backUrl,fields){
    const items=[];
    const frontField=findLayer(fields,FRONT_LAYER);
    const backField=findLayer(fields,BACK_LAYER);
    if(frontUrl&&frontField)items.push({field_id:frontField.field_id,type:'image',input:{image_url:frontUrl}});
    if(backUrl&&backField)items.push({field_id:backField.field_id,type:'image',input:{image_url:backUrl}});
    if(!items.length||!variantId)return null;
    const r=await fetch(`${API}/printifyPersonalization`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({shop_id:SHOP_ID,product_id:productId,variant_id:Number(variantId),items}),signal:abortAfter(20000)});
    const data=await r.json().catch(()=>({}));
    if(!r.ok||!data.personalisation_instructions){
      mockupLog.warn('personalization:code-failed',{status:r.status,productId,variantId,data});
      return null;
    }
    mockupLog.note('personalization:code',{productId,variantId,strategy:data.personalisation_strategy||''});
    return {strategy:data.personalisation_strategy||'',instructions:data.personalisation_instructions};
  }
  function catalogFromId(handle,catalog,printifyId){
    const known=knownByHandle(handle);
    const fuzzy=handle?CATALOG[catalogKeyFromHandle(handle)]:null;
    return {...(catalog||{}),...(fuzzy||{}),...(known||{}),handle,printifyId};
  }
  /** Catalog lookup that never touches the network; null when only the Printify list can answer. */
  function resolvePrintifySync(handle,catalog){
    const known=knownByHandle(handle);
    if(known?.printifyId)return {...catalog,...known,handle};
    if(PRINTIFY_IDS[handle])return catalogFromId(handle,catalog,PRINTIFY_IDS[handle]);
    if(catalog?.printifyId&&(!catalog.handle||sameProductHandle(catalog.handle,handle)))return {...catalog,handle,printifyId:catalog.printifyId};
    const kindHandle=(CATALOG[catalogKeyFromHandle(handle)]||{}).handle;
    if(kindHandle&&sameProductHandle(kindHandle,handle)&&PRINTIFY_IDS[kindHandle])return catalogFromId(handle,catalog,PRINTIFY_IDS[kindHandle]);
    return null;
  }
  async function resolvePrintify(handle,catalog){
    const sync=resolvePrintifySync(handle,catalog);
    if(sync)return sync;
    const list=await printifyProducts();
    const found=list.find(product=>matchesPrintifyHandle(product,handle));
    if(found)return catalogFromPrintify(found);
    return catalog;
  }
  const shopifyProductCache=new Map();
  function shopifyProduct(handle){
    if(!handle)return Promise.reject(new Error('Product is not available yet'));
    if(shopifyProductCache.has(handle))return shopifyProductCache.get(handle);
    const job=track((async()=>{
      const r=await fetch(`/products/${handle}.js`,{credentials:'same-origin'});
      if(!r.ok)throw new Error('Product is not available yet');
      return r.json();
    })());
    job.catch(()=>shopifyProductCache.delete(handle));
    shopifyProductCache.set(handle,job);
    return job;
  }
  const printifyProductCache=new Map();
  async function printifyProduct(id){
    if(!id)return null;
    if(printifyProductCache.has(id))return printifyProductCache.get(id);
    const job=track((async()=>{
      try{
        const r=await fetch(`${API}/printifyProduct?shop_id=${SHOP_ID}&product_id=${encodeURIComponent(id)}`,{signal:abortAfter(20000)});
        if(!r.ok){
          mockupLog.warn('product:fetch-failed',{id,status:r.status});
          return null;
        }
        const data=await r.json();
        if(!Array.isArray(data?.variants)||!data.variants.length){
          mockupLog.warn('product:no-variants',{id,keys:Object.keys(data||{}).slice(0,8)});
          return null;
        }
        return data;
      }catch(error){
        mockupLog.warn('product:fetch-error',{id,message:String(error?.message||error)});
        return null;
      }
    })());
    printifyProductCache.set(id,job);
    // A transient Printify/Functions hiccup must not poison the page for the whole session:
    // forget failed lookups so the next Apply or colour click fetches again.
    job.then(data=>{if(!data&&printifyProductCache.get(id)===job)printifyProductCache.delete(id);},()=>printifyProductCache.delete(id));
    return job;
  }
  function prefetchPrintify(catalog){
    if(!catalog?.printifyId)return;
    personalizationFields(catalog.printifyId);
    printifyProduct(catalog.printifyId);
  }
  // Cloud Functions cold-start in 2–5 s. A throwaway OPTIONS (answered 204 by the CORS handler, so no console
  // error) spins each instance up while the shopper is still designing instead of on the Apply click.
  let apiWarmed=false;
  function warmApiFunctions(){
    if(apiWarmed)return;
    apiWarmed=true;
    const run=()=>['printifyUpload','printifyPreview','printifyPreviewStatus'].forEach(name=>{
      fetch(`${API}/${name}?warm=1`,{method:'OPTIONS',mode:'cors',credentials:'omit',keepalive:true}).catch(()=>{});
    });
    if('requestIdleCallback' in window)requestIdleCallback(run,{timeout:2000});
    else setTimeout(run,300);
  }
  function preloadUrl(url){
    if(!url)return Promise.resolve();
    return new Promise(resolve=>{
      const img=new Image();
      const done=()=>resolve(url);
      img.onload=done;
      img.onerror=done;
      img.src=url;
    });
  }
  function preloadMockupSet(urls){
    if(!urls)return;
    const list=[urls.front,urls.back,...(urls.images||[])].filter(Boolean);
    [...new Set(list)].slice(0,8).forEach(preloadUrl);
  }
  function countryName(code){
    try{return new Intl.DisplayNames(['en'],{type:'region'}).of(String(code||'').toUpperCase())||String(code||'').toUpperCase();}
    catch(_){return String(code||'').toUpperCase();}
  }
  function itemLabel(item){
    if(item?.type==='text')return String(item.text||item.label||'Text').split('\n')[0].trim().slice(0,80)||'Text';
    const label=String(item?.label||item?.name||'').trim();
    if(label&&!/^[a-z]{2}$/i.test(label))return label;
    if(item?.type==='country'||(/^[a-z]{2}$/i.test(item?.value||'')&&item?.type!=='sports'&&item?.type!=='upload'))return countryName(item.value);
    return item?.value||'';
  }
  function sectionKind(item){
    if(item?.type==='text')return 'Text';
    if(isUploadItem(item))return 'Upload';
    if(item?.type==='country'||(!item?.type&&/^[a-z]{2}$/i.test(item?.value||'')))return 'Country';
    return 'Sports Team';
  }
  function desc(d){return (d.items||[]).slice(0,d.count).map(x=>{const over=x.type!=='text'&&String(x.overlay?.text||'').trim()?` (“${String(x.overlay.text).replace(/\s+/g,' ').trim().slice(0,60)}”)`:'';return `${sectionKind(x)}: ${itemLabel(x)}${over}`;}).join(' + ')}
  function readDraft(){try{return JSON.parse(localStorage.getItem('2in1flags:design:draft:v1'))}catch(e){return null}}
  const TOAST_KEY='2in1flags:mockup-toast:v1';
  const TOAST_MAX_MS=45000;
  function setMockupToast(active){
    const el=document.getElementById('hfd-mockup-toast');
    if(!el)return;
    if(active){
      window.__2in1MockupToastHold=true;
      el.classList.remove('is-leaving');
      el.hidden=false;
      return;
    }
    window.__2in1MockupToastHold=false;
    if(el.hidden)return;
    el.classList.add('is-leaving');
    setTimeout(()=>{
      if(el.classList.contains('is-leaving')&&!window.__2in1MockupToastHold){
        el.hidden=true;
        el.classList.remove('is-leaving');
      }
    },280);
  }
  function isMockupSrc(src){
    return /buyer-preview|images\.printify|cloudfront\.net\/buyer-preview/i.test(String(src||''));
  }
  function pageMockupImgs(page){
    return [...(page?.querySelectorAll('.product__media-list .product__media-item')||[])]
      .filter(item=>item.style.display!=='none')
      .map(item=>item.querySelector('img'))
      .filter(img=>img&&isMockupSrc(img.getAttribute('src')||img.currentSrc||''));
  }
  function flagGallerySlots(page){
    const items=[...(page?.querySelectorAll('.hfd__flag-product-gallery .product__media-item, .product__media-list .product__media-item')||[])]
      .filter(item=>item.style.display!=='none');
    const slots=items.map(item=>{
      const side=String(item.querySelector('.hfd__flag-media-label')?.textContent||'').trim().toLowerCase();
      const img=item.querySelector('img');
      return {side:side==='back'?'back':side==='front'?'front':'',img};
    }).filter(slot=>slot.img);
    if(slots.some(slot=>slot.side==='front'||slot.side==='back'))return slots.filter(slot=>slot.side==='front'||slot.side==='back');
    return pageMockupImgs(page).map((img,index)=>({side:index===0?'front':'back',img}));
  }
  function sameImageUrl(a,b){
    if(!a||!b)return false;
    if(a===b)return true;
    try{return new URL(a,location.href).href===new URL(b,location.href).href;}catch(_){return false;}
  }
  function slotImageSrc(img){
    return img?.getAttribute('src')||img?.currentSrc||'';
  }
  /** Both flag renders are on screen. Stock Printify URLs do not count once an applied URL is expected. */
  function galleryShows(page,expected){
    const slots=flagGallerySlots(page);
    if(!slots.length)return false;
    const wantBack=!!(expected?.back||expected?.front);
    if(wantBack&&!slots.some(slot=>slot.side==='back'))return false;
    return slots.every(slot=>{
      const img=slot.img;
      if(!img.complete||!(img.naturalWidth>0))return false;
      const src=slotImageSrc(img);
      if(!isMockupSrc(src))return false;
      if(!expected?.front)return true;
      const want=slot.side==='back'?(expected.back||expected.front):expected.front;
      return sameImageUrl(src,want);
    });
  }
  function isMockupPainted(page,expected){
    if(expected?.front)return galleryShows(page,expected);
    const slots=flagGallerySlots(page);
    if(slots.length>1)return slots.every(slot=>slot.img.complete&&slot.img.naturalWidth>0&&isMockupSrc(slotImageSrc(slot.img)));
    const img=pageMockupImgs(page)[0];
    return !!(img&&img.complete&&img.naturalWidth>0);
  }
  async function waitForMockupPaint(page,expected){
    if(!page)return;
    const until=Date.now()+20000;
    while(Date.now()<until){
      if(galleryShows(page,expected)){
        mockupLog.note('paint:ready',{slots:flagGallerySlots(page).map(slot=>slot.side)});
        return;
      }
      const pending=flagGallerySlots(page).map(slot=>slot.img).filter(img=>img&&!img.complete);
      if(pending.length){
        await Promise.race([
          Promise.all(pending.map(img=>new Promise(resolve=>{
            img.addEventListener('load',resolve,{once:true});
            img.addEventListener('error',resolve,{once:true});
          }))),
          sleep(Math.min(400,Math.max(50,until-Date.now())))
        ]);
      }else await sleep(80);
    }
    mockupLog.warn('paint:timeout',{
      expectedFront:expected?.front||'',
      expectedBack:expected?.back||'',
      slots:flagGallerySlots(page).map(slot=>({side:slot.side,src:slotImageSrc(slot.img),complete:!!slot.img.complete,w:slot.img.naturalWidth||0}))
    });
  }
  function quantize(value,digits){
    const n=Number(value);
    if(!Number.isFinite(n))return 0;
    const f=Math.pow(10,digits==null?4:digits);
    return Math.round(n*f)/f;
  }
  function textSig(item){
    if(window.__2in1FlagTextLayout?.signature)return window.__2in1FlagTextLayout.signature(item);
    if(item?.type!=='text'&&!item?.overlay?.text)return '';
    return [item?.type,item?.text,item?.font,item?.size,item?.color,item?.background,item?.align,item?.valign,item?.bold,item?.overlay?.text,item?.overlay?.font,item?.overlay?.size,item?.overlay?.color,item?.overlay?.align,item?.overlay?.valign,item?.overlay?.bold].join('|');
  }
  function designSig(draft){
    const slim=side=>({count:side?.count,cross:side?.cross,lineColor:side?.lineColor,lineSize:side?.lineSize,items:(side?.items||[]).map(i=>{
      const p=i.presentation;
      return {type:i.type,value:i.value,uploadId:i.uploadId,scale:quantize(i.scale||100,0),fitEntire:!!i.fitEntire,focus:i.focus==null?1:quantize(i.focus,0),tx:textSig(i),p:p&&Number(p.w)>0?[quantize(p.x),quantize(p.y),quantize(p.w),quantize(p.h)]:null};
    })});
    try{return JSON.stringify({f:slim(draft?.front),b:slim(draft?.back)});}catch(_){return '';}
  }
  function readMockups(){try{return JSON.parse(sessionStorage.getItem(MOCKUP_KEY)||'null')||{sig:'',frontUrl:'',backUrl:'',products:{}};}catch(_){return {sig:'',frontUrl:'',backUrl:'',products:{}};}}
  /** Both print files exist. Equal URLs are only trusted when the Back was deliberately mirrored from the Front. */
  function uploadsUsable(store){
    if(!store?.frontUrl||!store?.backUrl)return false;
    return store.frontUrl!==store.backUrl||!!store.backMirrored;
  }
  function writeMockups(store,token){
    if(token!=null&&token!==mockupRun){
      mockupLog.warn('store:write-skipped-stale-token',{token,mockupRun,loading:store?.loading,productCount:Object.keys(store?.products||{}).length});
      return;
    }
    try{sessionStorage.setItem(MOCKUP_KEY,JSON.stringify(store));}catch(_){ }
    window.__2in1Mockups=store;
    mockupLog.note('store:write',{
      loading:!!store?.loading,
      hasFrontUrl:!!store?.frontUrl,
      products:Object.keys(store?.products||{}),
      productFronts:Object.fromEntries(Object.entries(store?.products||{}).map(([h,p])=>[h,!!p?.front]))
    });
    document.dispatchEvent(new CustomEvent('2in1:mockups',{detail:store}));
  }
  function decodeShareDesign(value){
    try{
      const normalized=String(value||'').replace(/-/g,'+').replace(/_/g,'/');
      const binary=atob(normalized+'='.repeat((4-normalized.length%4)%4));
      const bytes=Uint8Array.from(binary,char=>char.charCodeAt(0));
      const design=JSON.parse(new TextDecoder().decode(bytes));
      return design?.front&&design?.back?design:null;
    }catch(_){return null;}
  }
  function adoptSharedDesignFromUrl(){
    const design=decodeShareDesign(new URLSearchParams(location.search).get('design'));
    if(!design)return null;
    const existing=readDraft();
    const draft=keepUploadIds({version:1,updatedAt:new Date().toISOString(),...design},existing);
    try{localStorage.setItem('2in1flags:design:draft:v1',JSON.stringify(draft));}catch(_){}
    const cached=readMockups();
    const identity=designSig(draft);
    if(cached.frontUrl&&identity&&(cached.designId===identity||cached.sig===identity))return draft;
    if(cached.sig&&cached.sig!==identity){
      try{sessionStorage.removeItem(MOCKUP_KEY);}catch(_){}
      window.__2in1Mockups=null;
    }
    return draft;
  }
  function cameraOf(item){
    const src=String(item?.src||'');
    const query=src.match(/[?&]camera_label=([^&]+)/i);
    if(query)return decodeURIComponent(query[1]).toLowerCase();
    const mock=String(item?.mockup_id||item?.camera_id||item?.position||item?.label||item?.camera_label||'');
    const named=mock.match(/(left|right|front|back|context-\d+)\s*$/i);
    return (named?named[1]:mock).toLowerCase();
  }
  function cameraIdOf(item){
    const src=String(item?.src||item?.mockup_id||'');
    const match=src.match(/mockup\/[^/]+\/\d+\/(\d+)\//i);
    return match?match[1]:'';
  }
  function defaultCamera(product){
    const images=product?.images||[];
    const chosen=images.find(img=>img.is_default)||images[0];
    return {label:cameraOf(chosen),id:cameraIdOf(chosen)};
  }
  function isFrontCamera(item){
    const cam=cameraOf(item);
    const raw=String(item?.mockup_id||item?.camera_id||item?.position||item?.label||item?.src||'');
    return cam==='front'||/(^|[^a-z])front([^a-z]|$)/i.test(raw);
  }
  function isBackCamera(item){
    const cam=cameraOf(item);
    const raw=String(item?.mockup_id||item?.camera_id||item?.position||item?.label||item?.src||'');
    return cam==='back'||/(^|[^a-z])back([^a-z]|$)/i.test(raw);
  }
  function pickMockups(preview,preferred=''){
    const list=preview?.mockups||preview?.data?.mockups||[];
    const personalized=list.filter(item=>/buyer-preview/i.test(item.src||''));
    const pool=personalized.length?personalized:list.filter(item=>!/folded|hanging/i.test(String(item.mockup_id||'')));
    const label=item=>String(item.mockup_id||item.camera_id||item.position||item.label||item.src||'');
    const want=typeof preferred==='string'?{label:preferred,id:''}:preferred||{};
    const wantLabel=String(want.label||'').toLowerCase();
    const wantId=String(want.id||'');
    const opposite={left:'right',right:'left',front:'back',back:'front'};
    const unlabeled=pool.length>1&&pool.every(item=>{
      const cam=cameraOf(item);
      return !cam||cam==='other'||(!isFrontCamera(item)&&!isBackCamera(item)&&!/^(left|right)$/i.test(cam));
    });
    // Prefer literal Front / Back cameras. Flag banners often label every camera "other".
    let frontItem=
      pool.find(item=>wantId&&cameraIdOf(item)===wantId)||
      (wantLabel==='front'?pool.find(isFrontCamera):null)||
      pool.find(item=>wantLabel&&cameraOf(item)===wantLabel)||
      pool.find(isFrontCamera)||
      pool[0];
    let backItem=
      pool.find(item=>item!==frontItem&&isBackCamera(item))||
      pool.find(item=>item!==frontItem&&cameraOf(item)===(opposite[cameraOf(frontItem)]||'back'))||
      null;
    if(backItem&&isFrontCamera(backItem)&&!isBackCamera(backItem)){
      backItem=pool.find(item=>item!==frontItem&&isBackCamera(item))||null;
    }
    // Double-sided banners expose only "other" cameras — use the next distinct mockup as back.
    if((!backItem||backItem===frontItem)&&(wantLabel==='front'||unlabeled)){
      backItem=pool.find(item=>item!==frontItem&&item?.src&&item.src!==frontItem?.src)||null;
    }
    const front=frontItem?.src||'';
    const back=backItem?.src||'';
    const images=[front,...(back&&back!==front?[back]:[]),...pool.map(item=>item.src).filter(src=>src&&src!==front&&src!==back)];
    mockupLog.note('pickMockups',{
      wantLabel,
      unlabeled,
      pool:pool.length,
      frontCam:frontItem?cameraOf(frontItem):null,
      backCam:backItem?cameraOf(backItem):null,
      distinct:!!(back&&back!==front)
    });
    return {front,back:back||front,images,hasDistinctBack:!!(back&&back!==front)};
  }
  function mockupCameraPreference(catalog,printify){
    const handle=String(catalog?.handle||'');
    if(catalog?.key==='flag'||catalog?.catalog==='flag'||/flag/i.test(handle)){
      // Flag Printify cameras are labeled via ?camera_label=front|back on the image URL.
      const images=printify?.images||[];
      const front=images.find(img=>cameraOf(img)==='front')||images.find(img=>img.is_default)||images[0];
      return {label:'front',id:cameraIdOf(front)};
    }
    return defaultCamera(printify);
  }
  async function ensureUploads(draft,token){
    // Prefer live designer emit (what you see) over draft/DOM snapshot defaults (visitor country).
    const bundle=liveDesignBundle();
    const snap=typeof window.twoInOneSavedDesignState==='function'?window.twoInOneSavedDesignState():null;
    const frontSource=mergeSidePresentation(
      hasSideContent(bundle?.front)?bundle.front:draft.front,
      snap?.front
    );
    let backSource=mergeSidePresentation(
      hasSideContent(bundle?.back)?bundle.back:(hasSideContent(draft.back)?draft.back:null),
      snap?.back
    );
    if(!hasSideContent(frontSource)){
      mockupLog.warn('upload:skip','missing front design state');
      return readMockups();
    }
    // Each side prints its own state, including an untouched visitor-country Back.
    // Only a missing Back falls back to the Front print file.
    let mirroredBack=false;
    if(!hasSideContent(backSource)){
      backSource=frontSource;
      mirroredBack=true;
    }
    // Lock BEFORE any await — otherwise two Apply clicks both hydrate then both upload (4 library files).
    const preSig=designSig({...draft,front:frontSource,back:backSource||frontSource});
    if(uploadInFlight){
      mockupLog.note('upload:join-in-flight',{preSig:preSig.slice(0,80),active:uploadInFlightSig.slice(0,80)});
      const shared=await uploadInFlight;
      if(token!=null&&token!==mockupRun)return readMockups();
      return shared;
    }
    uploadInFlightSig=preSig;
    uploadInFlight=(async()=>{
      try{
        mockupLog.note('upload:source',{
          source:bundle?.source||'draft',
          mirroredBack,
          visitor:visitorCountryCode(),
          front:desc(frontSource),
          back:desc(backSource||frontSource),
          frontCount:frontSource.count,
          backCount:(backSource||frontSource).count,
          frontValues:(frontSource.items||[]).slice(0,4).map(i=>i.value),
          backValues:((backSource||frontSource).items||[]).slice(0,4).map(i=>i.value),
          frontUrls:(frontSource.items||[]).slice(0,4).map(i=>itemUrl(i)),
          backUrls:((backSource||frontSource).items||[]).slice(0,4).map(i=>itemUrl(i))
        });
        const frontState=await hydrateUploads('front',frontSource);
        const backState=await hydrateUploads('back',backSource||frontSource,mirroredBack?{layoutSide:'front',skipLiveLayout:true}:null);
        const sig=designSig({...draft,front:frontState,back:backState});
        const printSize=printPixels().key;
        if(token!=null&&token!==mockupRun)return readMockups();
        const store=readMockups();
        if(uploadsUsable(store)&&(store.designId===sig||store.sig===sig)&&store.printSize===printSize){
          if(store.designId!==sig||store.sig!==sig){
            store.designId=sig;
            store.sig=sig;
            writeMockups(store,token);
          }
          return store;
        }
        // A Back the shopper made identical to the Front is the same print file — export and upload it once.
        const backIsMirror=designSig({front:frontState,back:null})===designSig({front:backState,back:null});
        const frontContents=await exportDesign(frontState,'front');
        const backContents=backIsMirror?frontContents:await exportDesign(backState,'back');
        mockupLog.note('upload:sides',{
          frontItems:(frontState.items||[]).slice(0,4).map(i=>({type:i.type,value:i.value})),
          backItems:(backState.items||[]).slice(0,4).map(i=>({type:i.type,value:i.value})),
          frontCross:frontState.cross,
          backCross:backState.cross,
          sameExport:frontContents===backContents,
          usedBackFallback:mirroredBack,
          backIsMirror,
          printSize,
          bytes:frontContents.length
        });
        if(!backIsMirror&&frontContents===backContents&&hasSideContent(backSource)&&designSig({front:frontState,back:null})!==designSig({front:backState,back:null})){
          mockupLog.warn('upload:identical-exports',{hint:'Front and Back image bytes matched despite different side state'});
        }
        // One side at a time. A full-size print file is large, and overlapping uploads were already unreliable.
        const front=await upload(frontContents,'2in1flags-Front-Design.jpg');
        if(token!=null&&token!==mockupRun)return readMockups();
        const back=backIsMirror?front:await upload(backContents,'2in1flags-Back-Design.jpg');
        if(token!=null&&token!==mockupRun)return readMockups();
        const next={
          sig,
          designId:sig,
          frontUrl:front.preview_url,
          backUrl:back.preview_url||front.preview_url,
          backMirrored:backIsMirror,
          printSize,
          products:{},
          loading:true
        };
        writeMockups(next,token);
        return next;
      }finally{
        uploadInFlight=null;
        uploadInFlightSig='';
      }
    })();
    return uploadInFlight;
  }
  function selectedVariantTitle(page){
    const root=page||document.querySelector('[data-product-design-page]');
    if(!root)return '';
    const groups=[...root.querySelectorAll('fieldset.product-form__input')];
    const values=groups.map(group=>{
      const checked=group.querySelector('input:checked');
      if(checked?.value)return checked.value;
      return group.querySelector('select')?.value||'';
    }).filter(Boolean);
    if(values.length)return values.join(' / ');
    const select=[...root.querySelectorAll('select[name^="options["]')].map(node=>node.value).filter(Boolean);
    if(select.length)return select.join(' / ');
    return root.querySelector('[data-size].is-active')?.dataset.size||'';
  }
  function colorKey(value){
    return String(value||'').toLowerCase().replace(/×/g,'x').replace(/[^a-z0-9]+/g,' ').trim();
  }
  function isSizeLike(value){
    const t=colorKey(value);
    const compact=t.replace(/ /g,'');
    if(/^(xxs|xs|s|m|l|xl|xxl|[2-5]xl|[2-5]x|onesize|os|\d+oz)$/.test(compact))return true;
    if(/^(small|medium|large|extra large|xx large|one size)$/.test(t))return true;
    if(/\d+\s*(oz|ounce)/.test(t))return true;
    if(/\d+\s*x\s*\d+/.test(t))return true;
    return false;
  }
  function normalizeSize(value){
    const t=colorKey(value);
    const compact=t.replace(/ /g,'');
    const aliases={xxs:'xxs','2xs':'xxs',xs:'xs',s:'s',small:'s',m:'m',medium:'m',l:'l',large:'l',xl:'xl','1xl':'xl',xlarge:'xl',extralarge:'xl',xxl:'2xl','2xl':'2xl','2x':'2xl',xxlarge:'2xl',xxxl:'3xl','3xl':'3xl','3x':'3xl',xxxxl:'4xl','4xl':'4xl','4x':'4xl','5xl':'5xl','5x':'5xl',onesize:'onesize',os:'onesize'};
    if(aliases[compact])return aliases[compact];
    const dim=t.match(/(\d+)\s*x\s*(\d+)/);
    if(dim)return `${dim[1]}x${dim[2]}`;
    const oz=compact.match(/^(\d+)(?:oz|ounce)s?$/);
    if(oz)return `${oz[1]}oz`;
    return compact;
  }
  function colorsMatch(a,b){
    if(!a||!b)return false;
    if(a===b)return true;
    if(a.length>=4&&b.includes(a))return true;
    if(b.length>=4&&a.includes(b))return true;
    return false;
  }
  function optionValues(value){
    if(value&&typeof value==='object'){
      const options=[value.option1,value.option2,value.option3].filter(part=>readableOption(part));
      if(options.length)return options;
      const named=value.options;
      if(named&&typeof named==='object'&&!Array.isArray(named)){
        return [named.color||named.Color,named.size||named.Size].filter(readableOption);
      }
      if(Array.isArray(named)){
        const readable=named.map(String).filter(readableOption);
        if(readable.length)return readable;
      }
      value=value.title;
    }
    return String(value||'').split('/').map(part=>part.trim()).filter(Boolean);
  }
  function readableOption(value){
    const text=String(value||'').trim();
    return !!text&&!/^\d+$/.test(text);
  }
  function variantParts(value){
    const title=norm(value&&typeof value==='object'?value.title:value);
    const options=optionValues(value);
    const sizeOpt=options.find(isSizeLike)||'';
    const colorOpt=options.find(part=>!isSizeLike(part))||'';
    return {title,size:normalizeSize(sizeOpt),color:colorKey(colorOpt)};
  }
  function variantFits(variant,want){
    const got=variantParts(variant);
    const wantSized=!!want.size&&want.size!=='onesize';
    const gotSized=!!got.size&&got.size!=='onesize';
    if(wantSized&&gotSized&&got.size!==want.size)return false;
    if(wantSized&&!gotSized)return false;
    if(want.size==='onesize'&&gotSized)return false;
    if(want.color&&!colorsMatch(got.color,want.color))return false;
    if(!want.size&&!want.color)return false;
    return !!(want.size||want.color);
  }
  function enabledVariants(list){
    const all=list||[];
    const enabled=all.filter(v=>v.is_enabled!==false);
    return enabled.length?enabled:all;
  }
  function pickPrintifyVariant(list,wanted){
    const available=enabledVariants(list);
    if(!available.length)return null;
    const want=variantParts(wanted);
    if(want.title){
      const exact=available.find(v=>norm(v.title)===want.title);
      if(exact)return exact;
    }
    if(want.size||want.color){
      const matches=available.filter(v=>variantFits(v,want));
      if(!matches.length)return null;
      return matches.sort((a,b)=>{
        const pa=variantParts(a),pb=variantParts(b);
        const colorScore=x=>x.color===want.color?2:colorsMatch(x.color,want.color)?1:0;
        return (colorScore(pb)-colorScore(pa))||(sizeScore(a.title)-sizeScore(b.title));
      })[0];
    }
    const isWhite=title=>{const t=norm(title);return t.includes('white')&&!t.includes('off white');};
    return available.find(v=>isWhite(v.title)&&/\bM\b/.test(v.title))||available.find(v=>isWhite(v.title))||available.find(v=>/\bM\b/.test(v.title))||available[0]||null;
  }
  function pickByTitle(list,title){return pickPrintifyVariant(list,title);}
  function colorFromTitle(title){
    const parts=String(title||'').split('/').map(part=>colorKey(part)).filter(Boolean);
    return parts.find(part=>!isSizeLike(part))||parts[parts.length-1]||'';
  }
  function sizeScore(title){
    const t=colorKey(title);
    if(/\bm\b/.test(t)||t.endsWith(' m'))return 0;
    if(/\bl\b/.test(t))return 1;
    if(/\bs\b/.test(t))return 2;
    return 3;
  }
  function uniqueColorVariants(printify){
    const byColor=new Map();
    (printify?.variants||[]).filter(v=>v.is_enabled!==false).forEach(variant=>{
      const color=colorFromTitle(variant.title);
      if(!color)return;
      const prev=byColor.get(color);
      if(!prev||sizeScore(variant.title)<sizeScore(prev.title))byColor.set(color,variant);
    });
    return [...byColor.entries()].map(([color,variant])=>({color,variant}));
  }
  function pageColorChoices(page){
    if(!page)return [];
    const groups=[...page.querySelectorAll('fieldset.product-form__input, .product-form__input')];
    const colorGroup=groups.find(group=>/color/i.test(group.querySelector('legend')?.textContent||group.getAttribute('name')||''));
    if(!colorGroup)return [];
    const sizeGroup=groups.find(group=>/size/i.test(group.querySelector('legend')?.textContent||group.getAttribute('name')||''));
    const size=sizeGroup?.querySelector('input:checked')?.value||sizeGroup?.querySelector('select')?.value||'';
    const values=[
      ...[...colorGroup.querySelectorAll('input[type="radio"]')].map(node=>node.value),
      ...[...colorGroup.querySelectorAll('select option')].map(node=>node.value)
    ].map(value=>String(value||'').trim()).filter(Boolean);
    return [...new Set(values)].map(value=>{
      const color=colorKey(value);
      if(!color||isSizeLike(value))return null;
      return {color, title:[size,value].filter(Boolean).join(' / ')};
    }).filter(Boolean);
  }
  function colorChoiceMatch(printifyColors,color){
    return printifyColors.find(item=>item.color===color||item.color.includes(color)||color.includes(item.color))||null;
  }
  function mergeProductMockup(store,handles,urls,color,shopify,printVariant){
    const payload=urls||{};
    handles.forEach(handle=>{
      const previous=store.products[handle]||{};
      const reuse=previous.designId===store.designId;
      const colors=reuse?{...(previous.colors||{})}:{};
      const variants=reuse?{...(previous.variants||{})}:{};
      if(color)colors[color]=payload;
      if(printVariant?.id){
        const printSize=variantParts(printVariant).size;
        (shopify?.variants||[]).forEach(v=>{
          const parts=variantParts(v);
          if(color&&colorFromTitle(v.title)!==color&&parts.color!==color)return;
          if(printSize&&parts.size&&parts.size!==printSize)return;
          if(color||printSize)variants[Number(v.id)]=payload;
        });
      }
      store.products[handle]={
        ...(reuse?previous:{}),
        ...payload,
        designId:store.designId,
        color:color||(reuse?previous.color:''),
        colors,
        variants,
        designArtOnly:!!payload.designArtOnly
      };
    });
    return store;
  }
  function isFlagCatalog(catalog,handle,page){
    if(catalog?.key==='flag'||catalog?.catalog==='flag')return true;
    if(/flag/i.test(String(handle||catalog?.handle||'')))return true;
    return !!page?.querySelector?.('.hfd__flag-product-gallery, .hfd__flag-media-label');
  }
  /** Drop flat design-art gallery entries so Apply waits for real Printify product mockups. */
  function clearDesignArtProducts(store,token){
    if(!store?.products)return store;
    let changed=false;
    Object.keys(store.products).forEach(handle=>{
      const product=store.products[handle];
      if(!product?.designArtOnly)return;
      delete store.products[handle];
      changed=true;
    });
    if(changed)writeMockups(store,token);
    return store;
  }
  function restoreFlagGalleryStock(page){
    if(!page?.querySelector?.('.hfd__flag-product-gallery'))return;
    page.classList.remove('has-printify-mockup');
    const stockFront=page.getAttribute('data-stock-front')||'';
    const stockBack=page.getAttribute('data-stock-back')||'';
    page.querySelectorAll('.hfd__flag-product-gallery .product__media-item').forEach(item=>{
      const side=String(item.querySelector('.hfd__flag-media-label')?.textContent||'').trim().toLowerCase();
      const stock=side==='back'?(stockBack||stockFront):stockFront;
      item.querySelectorAll('img').forEach(img=>{
        const src=stock||img.dataset.originalSrc;
        if(!src)return;
        img.dataset.originalSrc=src;
        img.removeAttribute('srcset');
        img.setAttribute('src',src);
      });
    });
  }
  /** @deprecated Kept unused — Apply no longer paints design-art fallbacks. */
  function seedDesignArtMockup(page,handle,store,token){
    return store;
  }
  const colorJobs=new Map();
  function designToken(store){
    return store?.designId||store?.sig||store?.frontUrl||'';
  }
  async function ensureProductColor(catalog,store,color,preferredTitle,token){
    const handle=primaryHandle(catalog.handle);
    const aliases=handlesFor(catalog);
    const want=colorKey(color||preferredTitle);
    mockupLog.note('color:start',{handle,printifyId:catalog.printifyId,color,preferredTitle,want});
    const existing=aliases.map(name=>store.products[name]).find(item=>item?.designId&&item.designId===store.designId&&!item?.stale&&!item?.designArtOnly&&(item?.colors?.[want]?.front||(item?.color===want&&item?.front)));
    if(existing?.colors?.[want]?.front){
      mockupLog.note('color:cache-hit',{handle,want,via:'colors'});
      return existing.colors[want];
    }
    if(existing?.color===want&&existing?.front){
      mockupLog.note('color:cache-hit',{handle,want,via:'product'});
      return existing;
    }
    // Key by design as well as variant. A size warm from the previous Apply stays in this map
    // until Printify finishes; joining it would hand the new design that task's old (or aborted) render.
    const jobKey=`${catalog.printifyId}:${designToken(store)}:${want||preferredTitle||'default'}`;
    if(colorJobs.has(jobKey))return colorJobs.get(jobKey);
    const job=(async()=>{
      const [fields,printify]=await Promise.all([
        personalizationFields(catalog.printifyId),
        printifyProduct(catalog.printifyId)
      ]);
      if(!findLayer(fields,FRONT_LAYER)){
        mockupLog.error('color:missing-front-layer',{handle,printifyId:catalog.printifyId,layers:(fields||[]).map(f=>f.label||f.field_id)});
        throw new Error('Missing Front Design layer');
      }
      const hasBack=!!findLayer(fields,BACK_LAYER);
      const variants=(printify?.variants||[]).filter(v=>v.is_enabled!==false);
      const preferred=pickPrintifyVariant(variants,preferredTitle||want);
      const wantParts=variantParts(preferredTitle||'');
      const sizeLocked=!!wantParts.size&&wantParts.size!=='onesize';
      const colorMatch=want?uniqueColorVariants(printify).find(item=>item.color===want||item.color.includes(want)||want.includes(item.color)):null;
      const variant=preferred||colorMatch?.variant||(!preferredTitle&&!want&&pickPrintifyVariant(variants,''))||null;
      if(!variant?.id){
        mockupLog.error('color:no-variant',{handle,preferredTitle,want,sample:(variants||[]).slice(0,5).map(v=>v.title)});
        throw new Error('No Printify variant');
      }
      mockupLog.note('color:variant',{handle,variantId:variant.id,title:variant.title,hasBack,sizeLocked});
      const preview=await createPreview(catalog.printifyId,variant.id,store.frontUrl,hasBack?store.backUrl:'',fields);
      if(token!=null&&token!==mockupRun)return null;
      const urls=pickMockups(preview,mockupCameraPreference(catalog,printify));
      if(!urls.front){
        mockupLog.error('color:no-mockup-url',{handle,previewStatus:preview?.status,mockupKeys:Object.keys(preview||{})});
        throw new Error('Printify did not return a mockup');
      }
      mockupLog.note('color:got-urls',{handle,front:String(urls.front).slice(0,100),back:!!urls.back,imageCount:(urls.images||[]).length});
      await Promise.race([preloadUrl(urls.front),sleep(1500)]);
      preloadMockupSet(urls);
      const resolvedColor=colorFromTitle(variant.title)||'';
      const resolvedSize=variantParts(variant).size||variantParts(preferredTitle||'').size||'';
      const cacheKeys=[resolvedColor,resolvedSize,want,colorKey(preferredTitle||'')].filter(Boolean);
      mergeProductMockup(store,aliases,urls,resolvedColor||resolvedSize,null,variant);
      aliases.forEach(handle=>{
        const product=store.products[handle];
        if(!product)return;
        product.colors=product.colors||{};
        cacheKeys.forEach(key=>{product.colors[key]=urls;});
      });
      writeMockups(store,token);
      shopifyProduct(handle).then(shopify=>{
        if(token!=null&&token!==mockupRun)return;
        const latest=readMockups();
        mergeProductMockup(latest,aliases,urls,resolvedColor||resolvedSize,shopify,variant);
        aliases.forEach(name=>{
          const product=latest.products[name];
          if(!product)return;
          product.colors=product.colors||{};
          cacheKeys.forEach(key=>{product.colors[key]=urls;});
        });
        writeMockups(latest,token);
      }).catch(()=>{});
      return urls;
    })().finally(()=>colorJobs.delete(jobKey));
    colorJobs.set(jobKey,job);
    return job;
  }
  // Flags: every size has its own Printify cameras, so a 12×18 mockup cannot stand in for 36×60. Once the
  // selected size has landed, render all remaining sizes in ONE Printify task (verified live: 4 variants →
  // 16 mockups tagged variant_id in ~50 s) so a size click swaps from cache instead of queuing a new render.
  const flagSizeJobs=new Map();
  function sizeKeyOf(variant){return normalizeSize(variantParts(variant).size||variant?.title||'');}
  function cachedSizeUrls(product,variant){
    if(!product?.colors)return null;
    const hit=product.colors[sizeKeyOf(variant)]||product.colors[colorKey(variant?.title)];
    return hit?.front&&!hit.designArtOnly?hit:null;
  }
  /** Fill per-size caches only — product-level front/back stay on the size the shopper selected. */
  function mergeSizeMockups(store,aliases,entries,shopify){
    aliases.forEach(handle=>{
      const previous=store.products[handle]||{};
      const reuse=previous.designId===store.designId;
      const product={...(reuse?previous:{}),designId:store.designId,colors:{...(reuse?(previous.colors||{}):{})},variants:{...(reuse?(previous.variants||{}):{})}};
      entries.forEach(({variant,urls})=>{
        const size=sizeKeyOf(variant);
        [size,colorKey(variant.title)].filter(Boolean).forEach(key=>{product.colors[key]=urls;});
        (shopify?.variants||[]).forEach(v=>{if(size&&variantParts(v).size===size)product.variants[Number(v.id)]=urls;});
      });
      store.products[handle]=product;
    });
    return store;
  }
  async function warmFlagSizes(catalog,token){
    if(!catalog?.printifyId)return null;
    const handle=primaryHandle(catalog.handle);
    const aliases=handlesFor(catalog);
    const store=readMockups();
    if(!store.frontUrl||(token!=null&&token!==mockupRun))return null;
    const designId=store.designId||store.sig;
    const jobKey=`${catalog.printifyId}:${designId}`;
    if(flagSizeJobs.has(jobKey))return flagSizeJobs.get(jobKey);
    let batch=null;
    const registered=[];
    batch=(async()=>{
      const [fields,printify]=await Promise.all([personalizationFields(catalog.printifyId),printifyProduct(catalog.printifyId)]);
      if(token!=null&&token!==mockupRun)return null;
      if(!findLayer(fields,FRONT_LAYER))return null;
      const hasBack=!!findLayer(fields,BACK_LAYER);
      const product=aliases.map(name=>readMockups().products[name]).find(item=>item?.designId===designId)||null;
      const pending=enabledVariants(printify?.variants).filter(v=>v?.id&&!cachedSizeUrls(product,v));
      if(!pending.length){mockupLog.note('sizes:all-cached',{handle});return new Map();}
      // A size clicked while this renders awaits the batch instead of queuing its own task.
      pending.forEach(v=>{
        const key=`${catalog.printifyId}:${designId}:${sizeKeyOf(v)}`;
        if(colorJobs.has(key))return;
        colorJobs.set(key,batch.then(map=>map?.get(v.id)?.urls||null));
        registered.push(key);
      });
      mockupLog.note('sizes:start',{handle,variants:pending.map(v=>v.title)});
      // Same task key on a reload, so a still-processing batch is resumed rather than re-queued.
      const preview=await createPreview(catalog.printifyId,pending.map(v=>v.id),store.frontUrl,hasBack?store.backUrl:'',fields,{pollMs:BACKGROUND_POLL_MS,background:true,shouldAbort:()=>token!=null&&token!==mockupRun});
      if(token!=null&&token!==mockupRun)return null;
      const list=preview?.mockups||preview?.data?.mockups||[];
      const pref=mockupCameraPreference(catalog,printify);
      const byVariant=new Map();
      pending.forEach(v=>{
        const own=list.filter(m=>Number(m.variant_id)===Number(v.id)||(Array.isArray(m.variant_ids)&&m.variant_ids.map(Number).includes(Number(v.id))));
        if(!own.length)return;
        const urls=pickMockups({mockups:own},pref);
        if(urls?.front)byVariant.set(v.id,{variant:v,urls});
      });
      mockupLog.note('sizes:got',{handle,mockups:list.length,rendered:[...byVariant.values()].map(x=>x.variant.title)});
      if(!byVariant.size)return byVariant;
      const shopify=await shopifyProduct(handle).catch(()=>null);
      if(token!=null&&token!==mockupRun)return null;
      const latest=readMockups();
      if((latest.designId||latest.sig)!==designId){mockupLog.note('sizes:design-changed',{handle});return null;}
      mergeSizeMockups(latest,aliases,[...byVariant.values()],shopify);
      writeMockups(latest,token);
      // Warm the browser cache off the critical path so the swap on click is instant.
      const idle=cb=>('requestIdleCallback' in window?requestIdleCallback(cb,{timeout:4000}):setTimeout(cb,500));
      idle(()=>byVariant.forEach(({urls})=>{preloadUrl(urls.front);if(urls.back&&urls.back!==urls.front)preloadUrl(urls.back);}));
      return byVariant;
    })().catch(err=>{
      mockupLog.warn('sizes:failed',{handle,err:String(err?.message||err)});
      return null;
    }).finally(()=>{
      flagSizeJobs.delete(jobKey);
      registered.forEach(key=>colorJobs.delete(key));
    });
    flagSizeJobs.set(jobKey,batch);
    return batch;
  }
  async function warmFlagSizesForPage(page,pageHandle,token){
    if(!page||!pageHandle||token!==mockupRun)return;
    if(!readMockups().frontUrl)return;
    const pageItem=await catalogItemForHandle(pageHandle,page).catch(()=>null);
    // Strict: only the flag banner. isFlagCatalog's /flag/ handle test would also match custom-flag-mug etc.
    const flagProduct=pageItem?.key==='flag'||pageItem?.catalog==='flag'||!!page.querySelector?.('.hfd__flag-product-gallery');
    if(!pageItem?.printifyId||token!==mockupRun||!flagProduct)return;
    return warmFlagSizes({...pageItem,handles:handlesFor(pageItem)},token);
  }
  async function mockupFor(catalog,store,preferredTitle='',token){
    if(!catalog.printifyId||!catalog.handle)return null;
    const aliases=handlesFor(catalog);
    const existing=aliases.map(handle=>store.products[handle]).find(item=>item?.front&&!item.stale&&item.designId&&item.designId===store.designId&&!item.designArtOnly);
    if(existing?.front){
      aliases.forEach(handle=>{if(!store.products[handle]?.front||store.products[handle]?.designArtOnly)store.products[handle]=existing});
      return existing;
    }
    return ensureProductColor(catalog,store,'',preferredTitle,token);
  }
  async function prefetchProductColors(catalog,store,token,preferredTitle){
    if(!catalog.printifyId||token!==mockupRun)return;
    const page=document.querySelector('[data-product-design-page]');
    const pageHandle=primaryHandle(page?.dataset.productHandle||'');
    if(!pageHandle||!handlesFor(catalog).some(handle=>primaryHandle(handle)===pageHandle))return;
    try{
      const printify=await printifyProduct(catalog.printifyId);
      if(token!==mockupRun)return;
      store=readMockups();
      const product=handlesFor(catalog).map(handle=>store.products[handle]).find(item=>item?.front||item?.colors)||{};
      preloadMockupSet(product);
      Object.values(product.colors||{}).forEach(preloadMockupSet);
      const printifyColors=uniqueColorVariants(printify);
      const pageColors=pageColorChoices(page);
      const preferredColor=colorFromTitle(preferredTitle)||pageColors.find(item=>item.color===colorKey(preferredTitle))?.color||'';
      const list=pageColors.length
        ?pageColors.map(item=>{
          const match=colorChoiceMatch(printifyColors,item.color);
          return {color:item.color, title:match?.variant?.title||item.title, variant:match?.variant};
        })
        :printifyColors.map(item=>({color:item.color, title:item.variant.title, variant:item.variant}));
      const pending=list.filter(({color})=>{
        const current=handlesFor(catalog).map(handle=>readMockups().products[handle]).find(item=>item?.front||item?.colors)||{};
        return !(current.colors?.[color]?.front||(current.color===color&&current.front&&current.designId===store.designId));
      }).sort((a,b)=>{
        if(preferredColor&&a.color===preferredColor)return -1;
        if(preferredColor&&b.color===preferredColor)return 1;
        return 0;
      });
      const worker=async()=>{
        while(pending.length){
          if(token!==mockupRun)return;
          const next=pending.shift();
          const latest=readMockups();
          if(!latest.frontUrl)return;
          const job=ensureProductColor(catalog,latest,next.color,next.variant?.title||next.title||'',token);
          const urls=await Promise.race([
            job,
            sleep(28000).then(()=>{throw new Error('Color mockup timed out')})
          ]).catch(err=>{
            console.warn('Color mockup skipped',catalog.handle,next.color,err);
            return null;
          });
          if(urls)preloadMockupSet(urls);
        }
      };
      const n=Math.min(MOCKUP_CONCURRENCY,pending.length);
      if(!n)return;
      await Promise.all(Array.from({length:n},worker));
    }catch(err){
      console.warn('Color prefetch skipped',catalog.handle,err);
    }
  }
  async function warmProductColors(page,pageHandle,token){
    if(!page||!pageHandle||token!==mockupRun)return;
    const store=readMockups();
    if(!store.frontUrl)return;
    const pageItem=await catalogItemForHandle(pageHandle,page).catch(()=>null);
    if(!pageItem?.printifyId||token!==mockupRun)return;
    return prefetchProductColors(pageItem,readMockups(),token,selectedVariantTitle(page));
  }
  let mockupRun=0;
  let toastTimer=0;
  let applyInFlight=null;
  // ---- Apply says "Applying…" only while this design's print files and the selected mockup are in flight.
  // Other colours and flag sizes keep rendering afterwards without holding the button, so a slow background
  // queue cannot leave the shopper stuck on "Applying…" until they reload. A design change bumps mockupRun,
  // which aborts that warm-up at its next token check.
  const WARM_HOLD_MS=5*60*1000;
  const warmHold={token:0,active:0,timer:0};
  function trackWarm(token,job,label){
    if(token!==mockupRun||!job||typeof job.then!=='function')return job;
    if(warmHold.token!==token){
      clearTimeout(warmHold.timer);
      warmHold.token=token;
      warmHold.active=0;
    }
    warmHold.active+=1;
    clearTimeout(warmHold.timer);
    // Safety valve: a stuck Printify task must not pin the button for the 10-minute background poll.
    warmHold.timer=setTimeout(()=>{
      if(warmHold.token!==token||!warmHold.active)return;
      mockupLog.warn('warm:hold-expired',{label,active:warmHold.active});
      warmHold.active=0;
      syncApplyButtons();
    },WARM_HOLD_MS);
    mockupLog.note('warm:start',{label,active:warmHold.active});
    syncApplyButtons();
    job.then(()=>{},()=>{}).then(()=>{
      if(warmHold.token!==token)return;
      warmHold.active=Math.max(0,warmHold.active-1);
      if(!warmHold.active)clearTimeout(warmHold.timer);
      mockupLog.note('warm:settled',{label,remaining:warmHold.active});
      syncApplyButtons();
    });
    return job;
  }
  let applyFailed=false;
  let applyFailReason='';
  function setApplyNote(text){
    document.querySelectorAll('.apply-design-note').forEach(note=>{
      if(!note.dataset.applyDiagnostic)note.dataset.originalText=note.textContent;
      note.textContent=text;
      note.dataset.applyDiagnostic='1';
    });
  }
  function applyNoteFor(reason){
    const text=String(reason||'');
    if(/timed out|pending/i.test(text))return 'Printify took too long to answer. Tap Apply to try again — a render already in progress will be continued.';
    if(/add text/i.test(text))return text;
    if(/can’t be printed|can't be printed/i.test(text))return 'Please change the text before applying. That language can’t be printed.';
    return 'Apply didn’t finish. Tap Apply to try again.';
  }
  function markApplyFailed(reason){
    applyFailed=true;
    applyFailReason=String(reason||'failed');
    if(/missing upload/i.test(applyFailReason)){
      explainMissingUpload(applyFailReason).catch(()=>{});
      return;
    }
    setApplyNote(applyNoteFor(applyFailReason));
  }
  async function listStoredUploadIds(){
    try{
      const db=await new Promise((resolve,reject)=>{
        const req=indexedDB.open('2in1flags-uploads',2);
        req.onupgradeneeded=()=>{if(!req.result.objectStoreNames.contains('images'))req.result.createObjectStore('images');};
        req.onsuccess=()=>resolve(req.result);
        req.onerror=()=>reject(req.error);
      });
      return await new Promise((resolve,reject)=>{
        const req=db.transaction('images','readonly').objectStore('images').getAllKeys();
        req.onsuccess=()=>resolve((req.result||[]).map(String));
        req.onerror=()=>reject(req.error);
      });
    }catch(_){return null;}
  }
  /** Put the missing-upload diagnosis on the page (no console needed): which slot, which id, what this device has. */
  async function explainMissingUpload(reason){
    const slot=(reason.match(/slot (\d+)/i)||[])[1]||'?';
    const wanted=mockupLog.steps.slice().reverse().find(s=>s.step==='export:missing-item')?.detail?.uploadId||'';
    const ids=await listStoredUploadIds();
    const stored=ids===null?'storage unavailable':`${ids.length} saved upload${ids.length===1?'':'s'} on this device`;
    mockupLog.warn('export:missing-upload-context',{slot,wanted,storedIds:ids});
    const text=`Image in slot ${slot}${wanted?` (${wanted})`:''} is not saved in this browser — ${stored}. Re-upload it in the designer, then Apply again.`;
    document.querySelectorAll('.apply-design-note').forEach(note=>{
      if(!note.dataset.applyDiagnostic)note.dataset.originalText=note.textContent;
      note.textContent=text;
      note.dataset.applyDiagnostic='1';
    });
  }
  function clearMissingUploadNote(){
    document.querySelectorAll('.apply-design-note[data-apply-diagnostic]').forEach(note=>{
      note.textContent=note.dataset.originalText||'';
      delete note.dataset.applyDiagnostic;
    });
  }
  function clearApplyFailed(){
    applyFailed=false;
    applyFailReason='';
    clearMissingUploadNote();
  }
  function applyFailLabel(){
    const reason=applyFailReason.toLowerCase();
    if(/timed out|pending|mockup/.test(reason))return 'Printify still rendering — tap to keep waiting';
    if(/add text/.test(reason))return 'Add text, then apply again';
    if(/can’t be printed|can't be printed|blocked/.test(reason))return 'Change the text, then apply again';
    if(/missing upload/.test(reason))return 'Uploaded image missing — re-add it in the designer';
    if(/upload|load design image|contents/.test(reason))return 'Upload failed — try again';
    return 'Apply failed — try again';
  }
  let uploadInFlight=null;
  let uploadInFlightSig='';
  function currentDesignIdentity(){
    const stored=readDraft();
    const draft=designerDraft(stored);
    return designSig(draft||stored);
  }
  function swappedIdentity(sig){
    try{
      const parsed=JSON.parse(sig||'');
      if(!parsed||typeof parsed!=='object')return sig;
      return JSON.stringify({f:parsed.b,b:parsed.f});
    }catch(_){return sig;}
  }
  function adoptSwappedMockups(){
    const store=readMockups();
    if(!store.frontUrl)return;
    const identity=swappedIdentity(store.designId||store.sig)||currentDesignIdentity();
    if(!identity)return;
    const next={...store,sig:identity,designId:identity,frontUrl:store.backUrl||store.frontUrl,backUrl:store.frontUrl||store.backUrl,products:{}};
    Object.entries(store.products||{}).forEach(([handle,product])=>{
      if(!product)return;
      const swapped={...product,front:product.back||product.front,back:product.front||product.back,images:[product.back,product.front,...(product.images||[])].filter(Boolean).filter((url,i,list)=>list.indexOf(url)===i)};
      if(product.colors){
        swapped.colors={};
        Object.entries(product.colors).forEach(([color,urls])=>{
          swapped.colors[color]={...urls,front:urls.back||urls.front,back:urls.front||urls.back};
        });
      }
      if(product.variants){
        swapped.variants={};
        Object.entries(product.variants).forEach(([id,urls])=>{
          swapped.variants[id]={...urls,front:urls.back||urls.front,back:urls.front||urls.back};
        });
      }
      swapped.designId=identity;
      next.products[handle]=swapped;
    });
    writeMockups(next);
  }
  let lastCatalogItems=null;
  function productHasFrontDesign(product){
    const layers=product?.sales_channel_properties?.personalisation?.layers||product?.personalization?.layers||[];
    if(layers.length)return layers.some(layer=>layerKey(layer.name||layer.label||layer.personalisation_id)==='front design');
    return null;
  }
  async function uniqueCatalogItems(){
    const byId=new Map(seedCatalogItems().map(item=>[item.printifyId,item]));
    let list=[];
    try{list=await printifyProducts();}catch(_){
      lastCatalogItems=[...byId.values()];
      return lastCatalogItems;
    }
    const extras=[];
    list.forEach(product=>{
      const mapped=catalogFromPrintify(product);
      const handle=mapped.handle||shopifyHandleFromPrintify(product);
      if(!product?.id||!handle)return;
      if(byId.has(product.id)){
        const prev=byId.get(product.id);
        const merged={...prev,...mapped,handle:handle||prev.handle,printifyId:product.id};
        merged.handles=handlesFor(merged);
        byId.set(product.id,merged);
        return;
      }
      extras.push({product,item:{...mapped,handle,printifyId:product.id}});
    });
    const accepted=await Promise.all(extras.map(async({product,item})=>{
      const hinted=productHasFrontDesign(product);
      if(hinted===true)return item;
      if(hinted===false)return null;
      const fields=await personalizationFields(item.printifyId);
      return findLayer(fields,FRONT_LAYER)?item:null;
    }));
    accepted.filter(Boolean).forEach(item=>{
      item.handles=handlesFor(item);
      byId.set(item.printifyId,item);
    });
    lastCatalogItems=[...byId.values()].filter(item=>item.printifyId&&item.handle);
    return lastCatalogItems;
  }
  function catalogItemsNow(){
    return lastCatalogItems||seedCatalogItems();
  }
  function visibleHandles(){
    const handles=new Set();
    document.querySelectorAll('[data-product-handle]').forEach(node=>{
      const handle=node.dataset.productHandle;
      if(handle)handles.add(primaryHandle(handle));
    });
    return handles;
  }
  function hasMockup(store,item){
    return handlesFor(item).some(handle=>{
      const product=store.products[handle];
      return product?.front&&product.designId===store.designId;
    });
  }
  function hasVisibleMockup(store){
    return Object.values(store.products||{}).some(item=>item?.front);
  }
  function catalogForPage(catalog,pageHandle){
    return catalog.find(item=>item.handles.some(handle=>primaryHandle(handle)===primaryHandle(pageHandle)));
  }
  async function catalogItemForHandle(handle,page){
    if(!handle)return null;
    const known=knownByHandle(handle);
    if(known?.printifyId){
      const resolved={...known,handle};
      return {...resolved,handles:handlesFor(resolved)};
    }
    const seed=page?catalogFor(page):{...(CATALOG[catalogKeyFromHandle(handle)]||CATALOG.merch),handle};
    const inherited=seed.printifyId&&sameProductHandle(seed.handle||handle,handle)?seed.printifyId:'';
    const printifyId=PRINTIFY_IDS[handle]||inherited||'';
    if(printifyId){
      const resolved={...seed,...(known||{}),handle,printifyId};
      return {...resolved,handles:handlesFor(resolved)};
    }
    const resolved=await resolvePrintify(handle,{...seed,handle,printifyId:''});
    if(!resolved?.printifyId)return null;
    return {...resolved,handles:handlesFor(resolved)};
  }
  async function prefetchPageColors(catalog,store,token,page,pageHandle){
    if(!pageHandle||token!==mockupRun)return;
    const current=catalogForPage(catalog,pageHandle);
    const extra=current||await resolvePrintify(pageHandle,{...(CATALOG[catalogKeyFromHandle(pageHandle)]||CATALOG.merch),handle:primaryHandle(pageHandle)});
    if(!extra?.printifyId)return;
    return prefetchProductColors({...extra,handles:handlesFor(extra)},store,token,selectedVariantTitle(page));
  }
  async function generateQueue(items,store,token,preferredByHandle){
    const pending=items.filter(item=>item.printifyId&&!hasMockup(store,item));
    let index=0;
    const worker=async()=>{
      while(index<pending.length){
        if(token!==mockupRun)return;
        const item=pending[index++];
        const preferred=item.handles.map(handle=>preferredByHandle[handle]).find(Boolean)||'';
        await mockupFor(item,store,preferred,token).catch(err=>console.warn('Printify mockup skipped',item.handle,err));
      }
    };
    const n=Math.min(MOCKUP_CONCURRENCY,pending.length);
    if(!n)return;
    await Promise.all(Array.from({length:n},worker));
  }
  function shouldWarmAllColors(page,options={}){
    if(typeof options.warmAllColors==='boolean')return options.warmAllColors;
    return String(page?.dataset?.mockupWarm||'')==='all';
  }
  function clearStaleMockups(options={}){
    const store=readMockups();
    // Never abort an in-flight Apply — draft autosaves can fire while Printify is still working.
    if(store.loading&&!options.force){
      mockupLog.note('store:stale-deferred','apply in progress');
      syncApplyButtons();
      return;
    }
    mockupRun+=1;
    // Drop in-flight colour/size joins. Those promises belong to the design that just went stale.
    colorJobs.clear();
    clearApplyFailed();
    // Keep last Front/Back images for display, but mark the design as stale so Apply is required again.
    // Restoring Shopify stock logos made Step 5 look broken after every draft autosave.
    const products=store.products||{};
    Object.values(products).forEach(product=>{
      if(!product)return;
      product.stale=true;
      product.designId='';
    });
    writeMockups({
      sig:'',
      designId:'',
      frontUrl:store.frontUrl||'',
      backUrl:store.backUrl||'',
      products,
      loading:false,
      stale:true
    });
    document.querySelectorAll('[data-product-design-page]').forEach(root=>{
      root.classList.remove('is-printify-loading');
    });
    mockupLog.note('store:stale-kept-gallery',{productCount:Object.keys(products).length});
    syncApplyButtons();
  }
  function productEntry(store,handle){
    if(!store?.products||!handle)return null;
    const direct=store.products[handle];
    if(direct?.front)return direct;
    const primary=primaryHandle(handle);
    if(store.products[primary]?.front)return store.products[primary];
    const aliases=handlesFor({handle,handles:[handle,primary]});
    for(const name of aliases){
      if(store.products[name]?.front)return store.products[name];
    }
    return Object.entries(store.products).find(([name,item])=>item?.front&&primaryHandle(name)===primary)?.[1]||null;
  }
  function pageMockupReady(page,store,identity){
    if(!page||!store?.frontUrl||store.stale)return false;
    const cachedPage=productEntry(store,page.dataset.productHandle||'');
    if(!cachedPage?.front||cachedPage.designArtOnly||cachedPage.stale)return false;
    if(!identity)return !store.loading;
    if(store.designId===identity||store.sig===identity)return true;
    // Applied mockups use a hydrated design sig; draft identity can differ slightly.
    if(cachedPage.designId&&(cachedPage.designId===store.designId||cachedPage.designId===store.sig))return !store.loading;
    return false;
  }
  function republishMockups(token){
    const store=readMockups();
    writeMockups({...store,loading:false},token);
  }
  function syncApplyButtons(){
    const draft=designerDraft(readDraft());
    const hasDraft=!!draft?.front;
    const identity=hasDraft?designSig(draft):'';
    const store=readMockups();
    const loading=!!store.loading;
    document.querySelectorAll('[data-apply-design]').forEach(btn=>{
      const page=btn.closest('[data-product-design-page]')||document.querySelector('[data-product-design-page]');
      const ready=pageMockupReady(page,store,identity);
      btn.disabled=!hasDraft||loading;
      btn.setAttribute('aria-busy',loading?'true':'false');
      // Never present Apply as "done": shoppers keep editing the flag and re-applying.
      btn.classList.remove('is-applied');
      const label=btn.querySelector('[data-apply-design-label]')||btn;
      if(loading)label.textContent='Applying…';
      else if(applyFailed&&!ready)label.textContent=applyFailLabel();
      else label.textContent='Apply Your Design';
    });
  }
  async function applyDesign(options={}){
    if(applyInFlight){
      mockupLog.note('apply:reuse-in-flight');
      return applyInFlight;
    }
    // Assign the promise synchronously so a second click in the same turn joins it.
    applyInFlight=(async()=>{
      try{
        clearApplyFailed();
        const page=document.querySelector('[data-product-design-page]');
        if(!page){
          mockupLog.warn('apply:skip','no [data-product-design-page]');
          return;
        }
        const draft=designerDraft(readDraft());
        if(!draft?.front){
          mockupLog.warn('apply:skip','no design draft');
          return;
        }
        syncApplyButtons();
        await generateMockups({
          warmAllColors:shouldWarmAllColors(page,options),
          ...options
        });
      }finally{
        applyInFlight=null;
        syncApplyButtons();
      }
    })();
    return applyInFlight;
  }
  window.__2in1ApplyDesign=applyDesign;
  async function generateMockups(options={}){
    const page=document.querySelector('[data-product-design-page]');
    if(!page){
      mockupLog.warn('generate:skip','no [data-product-design-page]');
      return;
    }
    const warmAll=shouldWarmAllColors(page,options);
    const stored=readDraft();
    const draft=designerDraft(stored);
    if(!draft?.front){
      mockupLog.warn('generate:skip','no design draft — design a flag first');
      return;
    }
    const pageHandle=page.dataset.productHandle||'';
    if(!pageHandle){
      mockupLog.warn('generate:skip','missing product handle');
      return;
    }
    mockupLog.note('generate:start',{pageHandle,title:selectedVariantTitle(page),warmAll});
    prefetchPrintify(catalogFor(page)||knownByHandle(pageHandle)||{printifyId:PRINTIFY_IDS[pageHandle]});
    const identity=designSig(draft);
    const cached=readMockups();
    // A kept gallery after an edit has a blank id on purpose (clearStaleMockups). Only backfill an id
    // when the stored sig already matches this design — never adopt the previous render as the new one.
    const productsStale=Object.values(cached.products||{}).some(product=>product?.stale);
    if(!cached.stale&&!productsStale&&cached.frontUrl&&identity&&!cached.designId&&cached.sig===identity){
      cached.designId=identity;
      Object.values(cached.products||{}).forEach(product=>{if(product&&!product.stale&&!product.designId)product.designId=identity;});
      writeMockups(cached);
    }
    const cachedPage=productEntry(cached,pageHandle);
    const cacheIsStale=!!cached.stale||!!cachedPage?.stale;
    const pageReady=!!(cachedPage?.front&&!cachedPage.designArtOnly&&!cacheIsStale&&(cachedPage.designId===identity||cached.designId===identity||cached.sig===identity||(cachedPage.designId&&(cachedPage.designId===cached.designId||cachedPage.designId===cached.sig))));
    const needsDesignBuild=cacheIsStale||!cached.frontUrl||!identity||(cached.designId!==identity&&cached.sig!==identity);
    const paintExpected=cachedPage?.front?{front:cachedPage.front,back:cachedPage.back||cachedPage.front}:null;
    const painted=isMockupPainted(page,paintExpected);
    mockupLog.note('generate:state',{
      pageHandle,
      hasFrontUrl:!!cached.frontUrl,
      pageReady,
      needsDesignBuild,
      painted,
      warmAll,
      loading:!!cached.loading,
      products:Object.keys(cached.products||{})
    });
    if(!needsDesignBuild&&pageReady){
      mockupLog.note('generate:already-ready',{pageHandle,warmAll,painted});
      const token=mockupRun||++mockupRun;
      if(!painted){
        const hold=readMockups();
        hold.loading=true;
        writeMockups(hold,token);
        await waitForMockupPaint(page,paintExpected);
      }
      if(warmAll)trackWarm(token,warmProductColors(page,pageHandle,token).catch(err=>console.warn('Color mockups skipped',err)),'colors');
      trackWarm(token,warmFlagSizesForPage(page,pageHandle,token).catch(err=>console.warn('Size mockups skipped',err)),'sizes');
      // Cache hit does not auto-paint after we stopped generating on page load — rebroadcast.
      republishMockups(token);
      return;
    }
    const token=++mockupRun;
    clearTimeout(toastTimer);
    let shownDesignToast=false;
    const hideToast=()=>{
      if(!shownDesignToast||token!==mockupRun)return;
      shownDesignToast=false;
      clearTimeout(toastTimer);
      setMockupToast(false);
    };
    // No full-page "Please wait…" toast — Apply button status is enough, and refresh must stay quiet.
    clearApplyFailed();
    try{
      if(token!==mockupRun)return;
      document.dispatchEvent(new CustomEvent('2in1:mockups-loading'));
      const loadingStore=readMockups();
      loadingStore.loading=true;
      writeMockups(loadingStore,token);
      syncApplyButtons();
      if(needsDesignBuild||!pageReady){
        const uploads=ensureUploads(draft,token);
        const pageItem=await catalogItemForHandle(pageHandle,page).catch(err=>{
          mockupLog.error('generate:catalog-fail',{pageHandle,err:String(err?.message||err)});
          return null;
        });
        mockupLog.note('generate:catalog',{pageHandle,printifyId:pageItem?.printifyId||null,handle:pageItem?.handle||null});
        prefetchPrintify(pageItem);
        const store=await uploads;
        if(token!==mockupRun)return;
        // Do not paint flat design-art fallbacks — Step 5 only shows Printify product mockups.
        clearDesignArtProducts(store,token);
        const awaiting=readMockups();
        const live=productEntry(awaiting,pageHandle);
        if(!live?.front||live.designArtOnly){
          restoreFlagGalleryStock(page);
          page.classList.add('is-printify-loading');
        }
        if(pageItem){
          const title=selectedVariantTitle(page);
          await mockupFor(pageItem,readMockups(),title,token).catch(err=>{
            const msg=String(err?.message||err);
            mockupLog.error('generate:mockup-skipped',{handle:pageItem.handle,err:msg});
            console.warn('Printify mockup skipped',pageItem.handle,err);
            markApplyFailed(msg);
          });
        }else{
          mockupLog.error('generate:no-printify-product',{pageHandle,hint:'Product not mapped in printify-catalog.js and not found via Printify API handle match'});
          markApplyFailed('no printify product');
        }
      }
      if(token!==mockupRun)return;
      const latest=readMockups();
      const entry=productEntry(latest,pageHandle);
      const hasUrl=!!entry?.front;
      mockupLog.note('generate:done',{pageHandle,hasUrl,products:Object.keys(latest.products||{}),loading:!!latest.loading});
      // Leave loading set. The button stays on "Applying…" until both gallery renders have loaded.
      if(hasUrl)await waitForMockupPaint(page,{front:entry.front,back:entry.back||entry.front});
      else{
        mockupLog.warn('generate:no-product-mockup',{pageHandle,hasFrontUrl:!!latest.frontUrl,hint:'Design uploaded but Printify preview never returned product images'});
        if(latest.frontUrl)markApplyFailed('Printify preview timed out');
      }
    }catch(err){
      markApplyFailed(err?.message||err);
      mockupLog.error('generate:failed',{err:String(err?.message||err)});
      console.warn('Printify mockups failed',err);
    }finally{
      if(token===mockupRun){
        hideToast();
        const hasPageMockup=!!productEntry(readMockups(),pageHandle)?.front;
        // Start the size/color hold before clearing loading so the label cannot flash back early.
        if(hasPageMockup&&warmAll)trackWarm(token,warmProductColors(page,pageHandle,token).catch(err=>console.warn('Color mockups skipped',err)),'colors');
        else if(!warmAll)mockupLog.note('generate:skip-color-warm','selected color only');
        else mockupLog.note('generate:skip-color-warm','primary mockup missing');
        if(hasPageMockup)trackWarm(token,warmFlagSizesForPage(page,pageHandle,token).catch(err=>console.warn('Size mockups skipped',err)),'sizes');
        const latest=readMockups();
        if(latest.loading){
          latest.loading=false;
          writeMockups(latest,token);
        }
        syncApplyButtons();
      }
    }
  }

  function cleanProperties(properties){
    const clean={};
    Object.entries(hideInternalLineProperties(properties)).forEach(([key,value])=>{
      clean[key]=String(value);
    });
    return clean;
  }
  async function addCartItem({id,quantity,properties,sections,sections_url}){
    const form=new FormData();
    form.append('id',String(id));
    form.append('quantity',String(quantity));
    Object.entries(cleanProperties(properties)).forEach(([key,value])=>form.append(`properties[${key}]`,value));
    if(sections?.length){
      form.append('sections',sections.join(','));
      if(sections_url)form.append('sections_url',sections_url);
    }
    return fetch('/cart/add.js',{method:'POST',body:form,credentials:'same-origin'});
  }

  // ---- Instant add-to-cart ---------------------------------------------------------------------
  // The click only needs data the browser already has, so /cart/add.js fires immediately. Printify
  // work (design upload, variant/field ids, mockup) runs afterwards and is patched onto the same
  // cart line with /cart/change.js. Pending lines are remembered so a later page (e.g. /cart) can
  // finish them if the shopper navigated away mid-way.
  const PENDING_LINES_KEY='2in1flags:cart-finalize:v1';
  const PENDING_LINE_TTL=24*60*60*1000;
  function readPendingLines(){try{return JSON.parse(localStorage.getItem(PENDING_LINES_KEY)||'[]')||[];}catch(_){return [];}}
  function writePendingLines(list){try{localStorage.setItem(PENDING_LINES_KEY,JSON.stringify(list.slice(-10)));}catch(_){ }}
  function rememberPendingLine(job){writePendingLines([...readPendingLines().filter(item=>item.key!==job.key),job]);}
  function forgetPendingLine(key){writePendingLines(readPendingLines().filter(item=>item.key!==key));}
  /** Persisted copy of a side: upload bytes dropped (rehydrated from the upload store by id on resume). */
  function stripUploadBytes(state){
    const copy=JSON.parse(JSON.stringify(state||{}));
    (copy.items||[]).forEach(item=>{
      const url=String(item?.imageUrl||'');
      if(url.startsWith('data:')||url.startsWith('blob:'))delete item.imageUrl;
      if(String(item?.value||'').startsWith('data:'))item.value=item.uploadId||'upload';
    });
    return copy;
  }
  /** Every upload slot that will print has image bytes — never export a design with a blank section. */
  function uploadsComplete(state){
    const count=Math.max(1,Number(state?.count)||1);
    return (state?.items||[]).slice(0,count).every(item=>{
      if(!isUploadItem(item))return true;
      const url=String(item?.imageUrl||item?.value||'');
      return url.startsWith('data:')||url.startsWith('blob:')||/^https?:\/\//i.test(url);
    });
  }
  function storedMockup(product,key){
    if(!product||!key)return null;
    const compact=normalizeSize(key);
    const spaced=compact.includes('x')?compact.replace(/x/g,' x '):'';
    return product.colors?.[key]||product.colors?.[compact]||(spaced?product.colors?.[spaced]:null)||null;
  }
  function cachedMockupFor(cached,handle,variantId,variant,designId){
    const empty={frontMock:'',backMock:''};
    if(!cached?.frontUrl||!designId||(cached.sig!==designId&&cached.designId!==designId))return empty;
    const productCached=cached.products?.[handle]||cached.products?.[primaryHandle(handle)]||{};
    if(productCached.designArtOnly)return empty;
    const title=typeof variant==='string'?variant:variant?.title||'';
    const parts=variantParts(variant||title);
    const selectedColor=colorFromTitle(title)||parts.color||'';
    const selectedSize=parts.size||'';
    const variantUrls=productCached.variants?.[variantId];
    const colorUrls=storedMockup(productCached,selectedColor);
    const sizeUrls=storedMockup(productCached,selectedSize);
    const storedColor=normalizeSize(productCached.color||'');
    const colorMatches=!!selectedColor&&(productCached.color===selectedColor||storedColor===normalizeSize(selectedColor)||storedColor===selectedSize);
    const sizeMatches=!!selectedSize&&storedColor===selectedSize;
    const sameSelection=colorMatches||sizeMatches||(!selectedColor&&!selectedSize);
    return {
      frontMock:variantUrls?.front||colorUrls?.front||sizeUrls?.front||(sameSelection?productCached.front:'')||'',
      backMock:variantUrls?.back||colorUrls?.back||sizeUrls?.back||(sameSelection?productCached.back:'')||''
    };
  }
  /** Mockup currently painted on the product gallery — the image the shopper is adding. */
  function paintedMockup(page){
    const imgs=pageMockupImgs(page);
    const front=imgs[0]?.currentSrc||imgs[0]?.getAttribute('src')||'';
    const back=imgs[1]?.currentSrc||imgs[1]?.getAttribute('src')||'';
    if(!isMockupSrc(front))return {frontMock:'',backMock:''};
    return {frontMock:front,backMock:isMockupSrc(back)&&back!==front?back:''};
  }
  function cartLineProperties(input){
    const {frontState,backState,hasBack,productTitle,handle,variantTitle,catalog,printify,printifyVariantId,frontField,backField,frontUrl,backUrl,frontMock,backMock,designId,personalisation}=input;
    const includeBack=hasBack!==false;
    return {
      'Front Design':desc(frontState),
      'Front Cross Section':frontState.cross,
      'Front Split Style':'line',
      'Front Line Size':frontState.lineSize,
      'Front Line Color':frontState.lineColor,
      'Back Design':includeBack?desc(backState):'',
      'Back Cross Section':includeBack?backState.cross:'',
      'Back Split Style':includeBack?'line':'',
      'Back Line Size':includeBack?backState.lineSize:'',
      'Back Line Color':includeBack?backState.lineColor:'',
      'Product':productTitle||handle,
      'Options':variantTitle,
      '_2in1_mockup_url':frontMock||'',
      '_2in1_back_mockup_url':backMock||'',
      '_2in1_front_image_url':frontUrl||'',
      '_2in1_back_image_url':backUrl||'',
      '_2in1_has_back':hasBack==null?'':hasBack?'1':'0',
      '_2in1_front_field_id':frontField?.field_id||'',
      '_2in1_back_field_id':backField?.field_id||'',
      '_2in1_printify_product_id':catalog?.printifyId||'',
      '_2in1_printify_variant_id':String(printifyVariantId||''),
      '_2in1_product_handle':primaryHandle(handle),
      '_2in1_blueprint_id':String(catalog?.blueprintId||printify?.blueprint_id||''),
      '_2in1_print_provider_id':String(catalog?.printProviderId||printify?.print_provider_id||''),
      '_2in1_design':designId||'',
      '_2in1_artwork':frontUrl?'ready':'pending',
      '_2in1_personalisation_instructions':personalisation?.instructions||'',
      '_2in1_personalisation_strategy':personalisation?.strategy||'',
      'personalisation_instructions':personalisation?.instructions||'',
      'personalisation_strategy':personalisation?.strategy||'',
      // Printify's Personalize button writes this exact name. Their Shopify import looks for it.
      'Personalization ID':personalisation?.instructions||''
    };
  }
  async function readCart(){
    const r=await fetch('/cart.js',{credentials:'same-origin'});
    if(!r.ok)throw new Error('Could not read cart');
    return r.json();
  }
  /** Replace a line's properties in place; resolves to the line's (possibly new) key. */
  async function patchCartLine(key,properties){
    const cart=await readCart();
    const line=(cart.items||[]).find(item=>item.key===key);
    if(!line)throw Object.assign(new Error('Cart line no longer in bag'),{gone:true});
    const clean=cleanProperties(properties);
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity:line.quantity,properties:clean})});
    if(!r.ok){
      const err=await r.json().catch(()=>({}));
      throw new Error(err.description||err.message||'Could not update cart line');
    }
    const next=await r.json();
    const updated=(next.items||[]).find(item=>item.variant_id===line.variant_id&&item.properties?._2in1_design===clean._2in1_design&&item.properties?._2in1_artwork===clean._2in1_artwork&&(item.properties?._2in1_mockup_url||'')===(clean._2in1_mockup_url||''));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(refreshCartImages,200);
    return updated?.key||key;
  }
  const finalizing=new Map();
  const previewing=new Set();
  async function finalizeCartLine(job,live){
    if(!job?.key)return;
    if(finalizing.has(job.key))return finalizing.get(job.key);
    const run=finalizeCartLineJob(job,live);
    finalizing.set(job.key,run);
    try{return await run;}
    finally{if(finalizing.get(job.key)===run)finalizing.delete(job.key);}
  }
  async function finalizeCartLineJob(job,live){
    const started=Date.now();
    try{
      const handle=job.handle;
      let catalog=await resolvePrintify(handle,{...(CATALOG[catalogKeyFromHandle(handle)]||CATALOG.merch),handle,printifyId:PRINTIFY_IDS[handle]});
      if(!catalog.printifyId){
        mockupLog.warn('cart:finalize-no-printify',{handle});
        forgetPendingLine(job.key);
        return;
      }
      const [fields,printify,shopify]=await Promise.all([
        personalizationFields(catalog.printifyId),
        printifyProduct(catalog.printifyId),
        shopifyProduct(handle).catch(()=>null)
      ]);
      const frontField=findLayer(fields,FRONT_LAYER);
      const backField=findLayer(fields,BACK_LAYER);
      if(!frontField){
        mockupLog.error('cart:finalize-no-front-layer',{handle,printifyId:catalog.printifyId});
        forgetPendingLine(job.key);
        return;
      }
      const hasBack=!!backField;
      const shopifyVariant=shopify?.variants?.find(v=>v.id===job.variantId)||null;
      const printifyVariant=pickPrintifyVariant(printify?.variants||[],shopifyVariant||job.variantTitle||'');
      let frontState=live?.frontState,backState=live?.backState;
      if(!frontState){
        frontState=await hydrateUploads('front',job.design?.front,{skipLiveLayout:true});
        backState=await hydrateUploads('back',job.design?.back,{skipLiveLayout:true,layoutSide:'back'});
      }
      const cached=readMockups();
      const printSize=printPixels(shopifyVariant?.title||job.variantTitle||'').key;
      let frontUrl='',backUrl='';
      if(cached.sig===job.designId&&uploadsUsable(cached)&&cached.printSize===printSize){
        frontUrl=cached.frontUrl;
        backUrl=cached.backUrl;
        mockupLog.note('cart:finalize-reuse-apply',{handle,printSize});
      }else{
        if(!uploadsComplete(frontState)||(hasBack&&!uploadsComplete(backState))){
          mockupLog.warn('cart:finalize-uploads-missing',{handle,hint:'Upload bytes unavailable on this page; line stays pending for a later page load.'});
          return;
        }
        const backIsMirror=designSig({front:frontState,back:null})===designSig({front:backState,back:null});
        const sizeLabel=shopifyVariant?.title||job.variantTitle||'';
        const frontContents=await exportDesign(frontState,'front',sizeLabel);
        frontUrl=(await upload(frontContents,'2in1flags-Front-Design.jpg')).preview_url;
        if(hasBack)backUrl=backIsMirror?frontUrl:(await upload(await exportDesign(backState,'back',sizeLabel),'2in1flags-Back-Design.jpg')).preview_url;
        if(frontUrl){
          writeMockups({...cached,sig:job.designId,designId:job.designId,frontUrl,backUrl:backUrl||frontUrl,backMirrored:!backUrl||backUrl===frontUrl,printSize,products:cached.printSize===printSize?(cached.products||{}):{}});
        }
      }
      if(!frontUrl)throw new Error('Printify upload returned no image URL');
      const mock=cachedMockupFor(readMockups(),handle,job.variantId,shopifyVariant||job.variantTitle||'',job.designId);
      const personalisation=printifyVariant?.id?await personalizationCode(catalog.printifyId,printifyVariant.id,frontUrl,hasBack?backUrl:'',fields):null;
      if(!personalisation?.instructions)mockupLog.warn('cart:no-personalization-code',{handle,variantId:printifyVariant?.id||''});
      const properties=cartLineProperties({
        frontState,backState,hasBack,
        productTitle:shopify?.title||job.productTitle,handle,
        variantTitle:shopifyVariant?.title||job.variantTitle||'',
        catalog,printify,printifyVariantId:printifyVariant?.id,
        frontField,backField,frontUrl,backUrl:hasBack?backUrl:'',
        frontMock:mock.frontMock,backMock:mock.backMock,designId:job.designId,personalisation
      });
      const key=await patchCartLine(job.key,properties);
      mockupLog.note('cart:finalized',{handle,ms:Date.now()-started,hadMockup:!!mock.frontMock});
      if(mock.frontMock||!printifyVariant?.id){
        forgetPendingLine(job.key);
      }else if(!previewing.has(job.key)){
        // Keep the line pending so a later page can resume. Checkout does not wait on this render.
        rememberPendingLine({...job,key});
        previewing.add(job.key);
        createPreview(catalog.printifyId,printifyVariant.id,frontUrl,hasBack?backUrl:'',fields).then(preview=>{
          const urls=pickMockups(preview,mockupCameraPreference(catalog,printify));
          if(!urls?.front)return;
          const store=readMockups();
          if(store.sig===job.designId||store.designId===job.designId){
            mergeProductMockup(store,handlesFor({...catalog,handle}),urls,colorFromTitle(shopifyVariant?.title||'')||'',shopify,printifyVariant);
            writeMockups(store);
            syncApplyButtons();
          }
          return patchCartLine(key,{...properties,'_2in1_mockup_url':urls.front,'_2in1_back_mockup_url':urls.back||''});
        }).then(()=>forgetPendingLine(key)).catch(err=>mockupLog.warn('cart:mockup-skipped',{handle,err:String(err?.message||err)})).finally(()=>previewing.delete(job.key));
      }
    }catch(err){
      if(err?.gone){
        forgetPendingLine(job.key);
        mockupLog.note('cart:finalize-line-gone',{key:job.key});
        return;
      }
      mockupLog.error('cart:finalize-failed',{key:job.key,err:String(err?.message||err)});
      throw err;
    }finally{
      syncCheckoutLock().catch(()=>{});
    }
  }
  function lineMissingArtwork(item){
    const props=item?.properties||{};
    if(!props._2in1_design&&!props._2in1_printify_product_id&&!props._2in1_product_handle)return false;
    return props._2in1_artwork!=='ready'||!/^https:\/\//i.test(String(props._2in1_front_image_url||''));
  }
  function lineMissingCode(item){
    const props=item?.properties||{};
    if(!props._2in1_design&&!props._2in1_printify_product_id&&!props._2in1_product_handle)return false;
    return !props['Personalization ID'];
  }
  function lineNeedsSave(item){return lineMissingArtwork(item)||lineMissingCode(item);}
  function cartLineImages(item){
    const props=item?.properties||{};
    const front=props._2in1_front_image_url||props._2in1_mockup_url||'';
    const back=props._2in1_back_image_url||'';
    return {front,back:back&&back!==front?back:''};
  }
  function lineHasVisibleInternalProperties(item){
    return Object.keys(item?.properties||{}).some(key=>customerPropertyName(key)!==key);
  }
  async function migrateVisibleInternalProperties(){
    let cart;
    try{cart=await readCart();}catch(_){return;}
    const pending=new Set(readPendingLines().map(job=>job.key));
    for(const item of cart.items||[]){
      if(pending.has(item.key)||!lineHasVisibleInternalProperties(item))continue;
      try{await patchCartLine(item.key,item.properties);}catch(err){mockupLog.warn('cart:hide-props-failed',{key:item.key,err:String(err?.message||err)});}
    }
  }
  function lineHasMockup(item){
    return /^https:\/\//i.test(String(item?.properties?._2in1_mockup_url||''));
  }
  async function finishPendingLines(options={}){
    const jobs=readPendingLines();
    if(!jobs.length)return;
    let cart=null;
    try{cart=await readCart();}catch(_){return;}
    const keys=new Set((cart.items||[]).map(item=>item.key));
    const now=Date.now();
    const runs=[];
    for(const job of jobs){
      if(!keys.has(job.key)||now-(job.createdAt||0)>PENDING_LINE_TTL){forgetPendingLine(job.key);continue;}
      const line=(cart.items||[]).find(item=>item.key===job.key);
      const missingArt=lineMissingArtwork(line);
      const missingCode=lineMissingCode(line);
      const missingMock=!lineHasMockup(line);
      if(!missingArt&&!missingCode&&!missingMock){forgetPendingLine(job.key);continue;}
      if(!missingArt&&!missingCode&&(!options.mockups||!missingMock||previewing.has(job.key)))continue;
      runs.push(finalizeCartLine(job).catch(err=>console.warn('Cart line finalize failed',err)));
    }
    await Promise.all(runs);
    await syncCheckoutLock().catch(()=>{});
  }
  function showDesignCheckoutNote(message){
    document.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach(btn=>{
      let note=btn.parentElement?.querySelector('[data-design-checkout-note]');
      if(!message){note?.remove();return;}
      if(!note){
        note=document.createElement('p');
        note.dataset.designCheckoutNote='';
        note.style.margin='0 0 0.8rem';
        note.style.fontSize='1.4rem';
        btn.parentElement?.insertBefore(note,btn);
      }
      note.textContent=message;
    });
  }
  async function syncCheckoutLock(){
    const jobs=readPendingLines();
    let locked=jobs.length>0;
    try{
      const cart=await readCart();
      locked=(cart.items||[]).some(lineNeedsSave);
    }catch(_){}
    document.documentElement.classList.toggle('is-design-pending',locked);
  }
  let checkoutPass=false;
  async function guardCartCheckout(event){
    if(checkoutPass){checkoutPass=false;return;}
    const form=event.target;
    if(!(form instanceof HTMLFormElement))return;
    if(form.id!=='cart'&&form.id!=='CartDrawer-Form')return;
    const submitter=event.submitter;
    if(submitter&&submitter.name&&submitter.name!=='checkout')return;
    // preventDefault has to happen before the first await, or the browser submits the unfinished design.
    const mightBePending=readPendingLines().length>0||document.documentElement.classList.contains('is-design-pending');
    if(!mightBePending)return;
    event.preventDefault();
    event.stopPropagation();
    let cart=null;
    try{cart=await readCart();}catch(_){cart=null;}
    if(cart&&!(cart.items||[]).some(lineNeedsSave)){
      showDesignCheckoutNote('');
      checkoutPass=true;
      const button=submitter||form.querySelector('[name="checkout"]');
      if(button&&form.requestSubmit)form.requestSubmit(button);
      else form.submit();
      return;
    }
    const buttons=[...document.querySelectorAll('#checkout, #CartDrawer-Checkout')];
    const labels=buttons.map(btn=>btn.textContent);
    buttons.forEach(btn=>{btn.setAttribute('aria-busy','true');btn.textContent='Saving your design…';});
    showDesignCheckoutNote('Saving your flag onto this order before checkout.');
    try{
      await finishPendingLines();
      const next=await readCart();
      if((next.items||[]).some(lineNeedsSave)){
        showDesignCheckoutNote('Your design did not finish saving. Remove this item, then add it again from the product page.');
        return;
      }
      showDesignCheckoutNote('');
      checkoutPass=true;
      const button=submitter||form.querySelector('[name="checkout"]');
      if(button&&form.requestSubmit)form.requestSubmit(button);
      else form.submit();
    }catch(err){
      console.warn('Checkout design save failed',err);
      showDesignCheckoutNote('Your design did not finish saving. Remove this item, then add it again from the product page.');
    }finally{
      buttons.forEach((btn,i)=>{btn.textContent=labels[i];btn.removeAttribute('aria-busy');});
    }
  }

  async function addFromProductForm(page,form,draft){
    let catalog=catalogFor(page);
    const handle=page.dataset.productHandle||catalog.handle;
    const submit=form.querySelector('[type="submit"]')||form.querySelector('[name="add"]');
    let status=page.querySelector('[data-product-status]');
    if(!status){status=document.createElement('p');status.dataset.productStatus='';form.appendChild(status)}
    const setStatus=text=>{status.textContent=text;if(submit)submit.setAttribute('aria-disabled','true')}
    try{
      if(submit){submit.classList.add('loading');submit.setAttribute('aria-disabled','true')}
      const variantId=Number(form.querySelector('[name="id"]')?.value);
      const qtyInput=form.elements?.quantity;
      const qtyNode=qtyInput?.length!=null?qtyInput[0]:qtyInput;
      const qty=Math.max(1,Number(qtyNode?.value||document.querySelector(`[form="${form.id}"][name="quantity"]`)?.value||form.querySelector('[name="quantity"]')?.value)||1);
      const ceiling=qtyNode&&window.cartQuantityCeiling?cartQuantityCeiling(qtyNode):window.cartQuantityLimit||999999;
      if(qty>ceiling){
        status.textContent=window.cartQuantityMessage?cartQuantityMessage(ceiling):`Enter ${Number(ceiling).toLocaleString()} or fewer. A larger quantity can't be saved to the cart.`;
        return;
      }
      if(!variantId)throw new Error('Choose a size and color');
      // Known catalog products resolve without any request; only unknown handles hit the Printify list.
      catalog=resolvePrintifySync(handle,catalog)||await resolvePrintify(handle,catalog);
      if(!catalog.printifyId)throw new Error('This product is not set up in Printify yet');
      draft=designerDraft(draft);
      const designId=designSig(draft);
      const [frontState,backState]=await Promise.all([
        hydrateUploads('front',draft.front),
        hydrateUploads('back',hasSideContent(draft.back)?draft.back:draft.front)
      ]);
      // Use whatever the page-load prefetch has already answered; anything missing is filled in afterwards.
      const fields=peek(fieldsCache.get(catalog.printifyId));
      const frontField=fields?findLayer(fields,FRONT_LAYER):null;
      const backField=fields?findLayer(fields,BACK_LAYER):null;
      const hasBack=fields?!!backField:null;
      const shopify=peek(shopifyProductCache.get(handle));
      const shopifyVariant=shopify?.variants?.find(v=>v.id===variantId)||null;
      const variantTitle=shopifyVariant?.title||selectedVariantTitle(page);
      const printify=peek(printifyProductCache.get(catalog.printifyId));
      const printifyVariant=printify&&(shopifyVariant||variantTitle)?pickPrintifyVariant(printify.variants||[],shopifyVariant||variantTitle):null;
      const cached=readMockups();
      const sameDesign=cached.sig===designId&&uploadsUsable(cached);
      const frontUrl=sameDesign?cached.frontUrl:'';
      const backUrl=sameDesign&&hasBack!==false?cached.backUrl:'';
      const mock=cachedMockupFor(cached,handle,variantId,shopifyVariant||variantTitle,designId);
      const painted=paintedMockup(page);
      if(!mock.frontMock&&painted.frontMock){
        mock.frontMock=painted.frontMock;
        if(!mock.backMock)mock.backMock=painted.backMock;
      }
      const personalisation=frontUrl&&printifyVariant?.id&&fields?await personalizationCode(catalog.printifyId,printifyVariant.id,frontUrl,backUrl,fields):null;
      const productTitle=shopify?.title||page.querySelector('.product__title h1, .product__title, h1')?.textContent?.trim()||'';
      const properties=cartLineProperties({
        frontState,backState,hasBack,productTitle,handle,variantTitle,catalog,printify,
        printifyVariantId:printifyVariant?.id,frontField,backField,frontUrl,backUrl,
        frontMock:mock.frontMock,backMock:mock.backMock,designId,personalisation
      });
      setStatus('Adding to bag…');
      const cartDrawer=document.querySelector('cart-drawer');
      const sections=cartDrawer?.getSectionsToRender?.().map(section=>section.id)||['cart-drawer','cart-icon-bubble'];
      const r=await addCartItem({id:variantId,quantity:qty,properties,sections,sections_url:window.location.pathname});
      const added=await r.json().catch(()=>({}));
      if(!r.ok)throw new Error(added.description||added.message||'Could not add to bag');
      setStatus('Added to bag.');
      document.dispatchEvent(new CustomEvent('2in1:design-added',{detail:{mockupUrl:mock.frontMock}}));
      if(cartDrawer?.renderContents&&added.sections){cartDrawer.renderContents(added);setTimeout(refreshCartImages,100)}
      else{document.dispatchEvent(new CustomEvent('cart:refresh'));document.querySelector('#cart-icon-bubble')?.click();setTimeout(refreshCartImages,500)}
      const artworkReady=properties._2in1_artwork==='ready'&&!!printifyVariant?.id&&!!frontField&&hasBack!=null&&(!!shopify||!!productTitle)&&!!properties['Personalization ID'];
      if(added.key&&(!artworkReady||!properties._2in1_mockup_url)){
        const job={
          key:added.key,
          variantId,
          handle,
          variantTitle,
          productTitle,
          designId,
          design:{front:stripUploadBytes(frontState),back:stripUploadBytes(backState)},
          createdAt:Date.now()
        };
        rememberPendingLine(job);
        syncCheckoutLock().catch(()=>{});
        mockupLog.note('cart:added-pending',{handle,artwork:properties._2in1_artwork,hasMockup:!!properties._2in1_mockup_url,hasVariant:!!printifyVariant?.id,hasFields:!!fields});
        finalizeCartLine(job,{frontState,backState}).catch(err=>console.warn('Cart line finalize failed',err));
      }else{
        mockupLog.note('cart:added-complete',{handle});
      }
    }catch(err){
      console.error(err);
      status.textContent=err.message||'Could not add personalized product.';
    }finally{
      if(submit){submit.classList.remove('loading');submit.removeAttribute('aria-disabled');submit.querySelector('.loading__spinner')?.classList.add('hidden')}
    }
  }

  function initProductPage(page){
    const draft=readDraft();
    const shared=!!new URLSearchParams(location.search).get('design');
    // Warm everything add-to-cart reads so the click itself needs only /cart/add.js.
    const handle=page.dataset.productHandle||'';
    if(handle){
      const known=resolvePrintifySync(handle,catalogFor(page));
      if(known?.printifyId)prefetchPrintify(known);
      shopifyProduct(handle).catch(()=>{});
    }
    warmApiFunctions();
    // Cached design on load: fill (or resume) the other flag sizes so the first size click is instant.
    if(handle&&productEntry(readMockups(),handle)?.front){
      const token=mockupRun;
      const run=()=>trackWarm(token,warmFlagSizesForPage(page,primaryHandle(handle),token).catch(err=>console.warn('Size mockups skipped',err)),'sizes-resume');
      if('requestIdleCallback' in window)requestIdleCallback(run,{timeout:3000});else setTimeout(run,800);
    }
    if(!draft?.front&&!shared&&!page.closest('[data-hfd]')){
      const info=page.querySelector('.product__info-container');
      if(info&&!page.querySelector('[data-design-missing]')){
        const note=document.createElement('p');
        note.dataset.designMissing='';
        note.innerHTML='<a href="/?scroll=designer">Design your flag</a> first, then come back to print it on this product.';
        info.prepend(note);
      }
    }
    page.addEventListener('submit',e=>{
      const form=e.target.closest('form[data-type="add-to-cart-form"]');
      if(!form)return;
      const current=designerDraft(readDraft());
      if(!current?.front)return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addFromProductForm(page,form,current);
    },true);
  }

  function paintDesignImage(img,url){
    img.referrerPolicy='no-referrer';
    img.src=url;
    img.removeAttribute('srcset');
  }
  function paintCartRoot(root,items){
    if(!root)return;
    const rows=[...root.querySelectorAll('.cart-item')];
    items.forEach((item,i)=>{
      const images=cartLineImages(item);
      const row=rows[i];
      if(!images.front||!row)return;
      const frontImg=row.querySelector('[data-design-front]')||row.querySelector('img.cart-item__image')||row.querySelector('img');
      if(!frontImg||frontImg.closest('[data-design-print]'))return;
      paintDesignImage(frontImg,images.front);
      frontImg.setAttribute('data-design-front','');
      if(!images.back)return;
      let backImg=row.querySelector('[data-design-back]');
      if(!backImg){
        const design=frontImg.closest('.cart-item__design')||frontImg.parentElement;
        const pair=frontImg.closest('.cart-item__designs')||design;
        if(!design||!pair)return;
        pair.classList.add('cart-item__designs--pair');
        if(!design.querySelector('.cart-item__design-label')){
          const frontLabel=document.createElement('span');
          frontLabel.className='cart-item__design-label';
          frontLabel.textContent='Front';
          design.prepend(frontLabel);
        }
        const backWrap=document.createElement('span');
        backWrap.className='cart-item__design';
        const backLabel=document.createElement('span');
        backLabel.className='cart-item__design-label';
        backLabel.textContent='Back';
        backImg=frontImg.cloneNode(false);
        backImg.classList.add('cart-item__image--back');
        backImg.removeAttribute('data-design-front');
        backImg.alt=`${(item.product_title||item.title||'Design')} back`;
        backWrap.append(backLabel,backImg);
        pair.append(backWrap);
      }
      backImg.setAttribute('data-design-back','');
      paintDesignImage(backImg,images.back);
    });
  }
  async function refreshCartImages(){
    try{
      const cart=await fetch('/cart.js').then(r=>r.json());
      paintCartRoot(document.querySelector('cart-drawer'),cart.items||[]);
      paintCartRoot(document.getElementById('main-cart-items'),cart.items||[]);
      paintCartRoot(document.getElementById('cart-notification'),cart.items||[]);
    }catch(e){}
  }

  function init(){
    adoptSharedDesignFromUrl();
    setMockupToast(false);
    const page=document.querySelector('[data-product-design-page]');
    if(page)initProductPage(page);
    if(!document.getElementById('design-checkout-lock-style')){
      const style=document.createElement('style');
      style.id='design-checkout-lock-style';
      style.textContent='html.is-design-pending .additional-checkout-buttons{visibility:hidden;height:0;overflow:hidden;margin:0;padding:0}';
      document.head.appendChild(style);
    }
    refreshCartImages();
    migrateVisibleInternalProperties().catch(()=>{}).then(()=>finishPendingLines({mockups:true})).catch(()=>{});
    syncCheckoutLock().catch(()=>{});
    document.addEventListener('submit',event=>{guardCartCheckout(event).catch(err=>console.warn('Checkout design save failed',err));},true);
    syncApplyButtons();
    document.addEventListener('click',event=>{
      const btn=event.target.closest?.('[data-apply-design]');
      if(!btn||btn.disabled)return;
      event.preventDefault();
      event.stopPropagation();
      applyDesign().catch(err=>console.warn('Printify mockups failed',err));
    });
    document.addEventListener('2in1:draft-saved',()=>{
      document.querySelectorAll('[data-design-missing]').forEach(el=>el.remove());
      const identity=designSig(designerDraft(readDraft()));
      const cached=readMockups();
      if(cached.loading){
        mockupLog.note('draft-saved:ignored-during-apply');
        syncApplyButtons();
        return;
      }
      if(cached.frontUrl&&identity&&(cached.designId===identity||cached.sig===identity)){
        syncApplyButtons();
        return;
      }
      if(cached.frontUrl&&identity&&swappedIdentity(cached.designId||cached.sig)===identity){
        adoptSwappedMockups();
        syncApplyButtons();
        return;
      }
      if(cached.frontUrl||Object.keys(cached.products||{}).length)clearStaleMockups();
      else syncApplyButtons();
    });
    document.addEventListener('flag:sides-swapped',()=>{
      adoptSwappedMockups();
      syncApplyButtons();
    });
    document.addEventListener('2in1:need-color',event=>{
      const page=document.querySelector('[data-product-design-page]');
      if(!page)return;
      const detail=event.detail||{};
      const handle=primaryHandle(detail.handle||'');
      if(!handle||primaryHandle(page.dataset.productHandle||'')!==handle)return;
      const store=readMockups();
      if(!store.frontUrl)return;
      const catalog={...(CATALOG[catalogKeyFromHandle(handle)]||CATALOG.merch),handle,printifyId:detail.printifyId||PRINTIFY_IDS[handle]};
      resolvePrintify(handle,catalog).then(item=>{
        if(!item.printifyId)return;
        const latest=readMockups();
        if(!latest.frontUrl)return;
        return ensureProductColor({...item,handles:handlesFor(item)},latest,colorKey(detail.color||detail.title||''),detail.title||'',mockupRun);
      }).catch(err=>console.warn('Color mockup skipped',handle,err));
    });
    document.addEventListener('2in1:mockups',syncApplyButtons);
    document.addEventListener('2in1:mockups-loading',syncApplyButtons);
    window.addEventListener('pageshow',()=>{
      try{sessionStorage.removeItem(TOAST_KEY);}catch(_){}
      if(window.__2in1MockupToastHold)return;
      setMockupToast(false);
      syncApplyButtons();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
